<style lang="scss">
@keyframes anime {
  0% {
    transform: scale(1.5);
    opacity: 1;
  }
  90% {
    opacity: 0.1;
  }
  to {
    transform: scale(1.5, 1.5);
    opacity: 0;
  }
}
#lobby_page,
#dvlobby {
  display: none;
}
/*#topmenu.topmenu{
    display:block !important;
  }*/
.hooper-track li.hooper-slide {
  height: auto !important;
}

.lobby-page-wrapper .link-wrapper {
  position: absolute;
  font-size: 18px;
  top: 0px;
  right: 15px;
  padding: 5px 15px;
  background: rgba(255, 255, 255, 0.8);
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
  box-shadow: 1px 1px 8px 0 rgba(35, 31, 32, 0.12);
  z-index: 999;
}
.lobby-page-wrapper .link-wrapper .logout-link {
  background-image: url("../assets/Images/icons/logout-black.svg");
  background-size: 15px;
  background-repeat: no-repeat;
  background-position: 100% center;
  padding-right: 22px;
  cursor: pointer;
}
.lobby-page-wrapper .link-wrapper .back-link {
  background-image: url("../assets/Images/icons/go-back.svg");
  background-size: 15px;
  background-repeat: no-repeat;
  background-position: left center;
  padding-left: 22px;
  padding-right: 15px;
  margin-right: 15px;
  border-right: 1px solid #e8e8e8;
  cursor: pointer;
}
.lobby-page-wrapper .link-wrapper .back-link a {
  color: #212529;
}
.lobby-page-wrapper logout-link .event-unpublished {
  pointer-events: none;
}
.page-wrap-inner {
  padding-top: 0 !important;
}

#lobby_page {
  padding-left: 80px;
}
.dot {
  position: absolute;
  width: 24px !important;
  height: 24px !important;
  background: rgba(white, 1);
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.2);
  line-height: 24px;
  font-size: 12px;
  font-weight: bold;
  transition: 0.2s;
  z-index: 9999;
  &.ui-draggable-dragging {
    box-shadow: 0 0 25px 0 rgba(0, 0, 0, 0.5);
    transform: scale3d(1.2, 1.2, 1.2);
    background: rgba(white, 0.7);
  }
}
.dot:before,
.dot:after {
  content: "";
  position: absolute;
  z-index: 99;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  border-radius: 32px;
  background: #f5f5f5;
  transform: translate3d(0, 0, 0);
}
.dot:before {
  animation: anime 2s ease-out infinite;
}
.dot:after {
  animation: anime 2s ease-out 1s infinite;
}
.center-panel {
  position: relative;
}
.virtual-lobby-image:after {
  content: "";
  position: absolute;
  /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#ffffff+4,ffffff+96&1+0,0+7,0+94,1+100 */
  // background: -moz-linear-gradient(
  //   left,
  //   rgba(255, 255, 255, 1) 0%,
  //   rgba(255, 255, 255, 0.43) 4%,
  //   rgba(255, 255, 255, 0) 7%,
  //   rgba(255, 255, 255, 0) 94%,
  //   rgba(255, 255, 255, 0.33) 96%,
  //   rgba(255, 255, 255, 1) 100%
  // ); /* FF3.6-15 */
  // background: -webkit-linear-gradient(
  //   left,
  //   rgba(255, 255, 255, 1) 0%,
  //   rgba(255, 255, 255, 0.43) 4%,
  //   rgba(255, 255, 255, 0) 7%,
  //   rgba(255, 255, 255, 0) 94%,
  //   rgba(255, 255, 255, 0.33) 96%,
  //   rgba(255, 255, 255, 1) 100%
  // ); /* Chrome10-25,Safari5.1-6 */
  // background: linear-gradient(
  //   to right,
  //   rgba(255, 255, 255, 1) 0%,
  //   rgba(255, 255, 255, 0.43) 4%,
  //   rgba(255, 255, 255, 0) 7%,
  //   rgba(255, 255, 255, 0) 94%,
  //   rgba(255, 255, 255, 0.33) 96%,
  //   rgba(255, 255, 255, 1) 100%
  // ); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  // filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#ffffff',GradientType=1 ); /* IE6-9 */
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
}

.mouse-cursor {
  position: absolute;
  bottom: -30px;
  left: 50%;
  transform: translateX(-50%);
}

.virtual-lobby-image a:hover .mouse-cursor {
  display: none;
}

.virtual-lobby-image.test a:hover {
  cursor: url("https://firebasestorage.googleapis.com/v0/b/e2monair.firebasestorage.app/o/OA_UAT%2FDefaults%2Fimage%2Fcustome-cursor.png?alt=media"),
    auto;
}

.virtual-lobby-image a:hover {
  /* for achieving the arrow shape at the bottom of the tooltip */
  text-decoration: none;
}
.virtual-lobby-image a::after,
.virtual-lobby-image a::before {
  position: absolute;
  display: none; /* initially hide it from view */
}

.virtual-lobby-image a[data-tooltip]::after {
  content: attr(
    data-tooltip
  ); /* set content of pseudo element as the value of data-tooltip attribute */
  top: 100%;
  right: 0;
  background: #dfdfdf;
  border: 1px solid #00a148;
  border-radius: 4px; /* just a bit of extra styling */
  padding: 2px 6px;
  white-space: nowrap;
  color: #00a148;
  font-weight: 600;
  font-size: 14px;
}
.virtual-lobby-image a:hover::after,
.virtual-lobby-image a:hover::before {
  display: block; /* display both tooltip and arrow mark when a is hovered on */
}
.mouse-hide {
  display: none;
}
.event-name-div {
  display: none;
}
.hostBy {
  display: none;
}
.lobbypage-custome-modal .modal-body {
  position: relative;
}
.lobbypage-custome-modal .modal-body button.close {
  position: absolute;
  top: -12px;
  right: -6px;
  display: inline-flex;
  float: none;
  font-size: 1.5rem;
  font-weight: 400;
  line-height: 0;
  text-shadow: none;
  opacity: 1;
  height: 30px;
  width: 30px;
  color: #fff;
  background: #333;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
}
.lobbypage-custome-modal .modal-body iframe {
  width: 100%;
  height: 800px;
}

@media only screen and (min-width: 1367px) and (max-width: 1800px) {
  .lobbypage-custome-modal .modal-body iframe {
    width: 100%;
    height: 566px;
  }
}
@media only screen and (max-width: 1366px) {
  .lobbypage-custome-modal .modal-body iframe {
    width: 100%;
    height: 540px;
  }
}
@media only screen and (max-width: 767px) {
  .join-now-btn {
    max-width: 185px !important;
    background-color: #16da6b !important;
    box-shadow: 0px 10px 0px #eae6e6 !important;
    border-radius: 11px !important;
  }
  .main-container-hld .center-panel .centr-heading {
    font-size: 16px !important;
  }
  #lobby_page.lobby-page.main-container-hld .center-panel .centr-heading {
    min-width: 158px !important;
    padding: 9px 10px !important;
  }
  .event-name-div {
    display: block;
  }
  .hostBy {
    margin: 0 !important;
    font-size: 14px !important;
    font-weight: 400 !important;
    color: #ffff !important;
    margin-bottom: 0 !important;
    margin-top: 20px !important;
  }
  // .audio-vol-icon {
  //   position: relative !important;
  //   left: 0 !important;
  //   transform: inherit !important;
  // }
  // .audio-vol-icon {
  //   bottom: 0 !important;
  // }
  #lobby_page {
    font-size: 16px !important;
  }
  .event-name-div {
    font-size: 16px !important;
    font-weight: 600 !important;
    color: #ffffff !important;
    margin-bottom: 7px !important;
  }
  .lobby-page-header-panel.center-panel {
    height: 100vh !important;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  .lobby-page-header-panel .timer-hld {
    display: none !important;
  }
  .lobby-page-header-panel #headerText {
    display: none !important;
  }

  .main-container-hld .center-panel .centr-heading {
    margin-bottom: 15px !important;
  }
  #audioWrapper {
    display: none !important;
  }
}
</style>
<template>
  <div>
    <!-- showSaudiSplash flag controls which layout renders.
         true  = Saudi video splash + Enter button (default)
         false = legacy lobby (photowall, leaderboard, sponsor
                 panels) - preserves the pre-Saudi behavior. -->
    <div
      v-if="showSaudiSplash && saudiLobbyVideoUrl"
      class="saudi-lobby"
    >
      <!-- Full-screen background video. `playsinline` is needed for iOS;
           NO hardcoded `muted` here — desktop browsers autoplay with
           sound (matches legacy customHtml behavior). iOS gets forced
           muted + sound-toggle button via enhanceLobbyVideos() in JS,
           same as the legacy .virtual-lobby-image flow. Source comes
           from VirtualLobby.ImgHotspotHTML; if no <video>/<source>
           tag, this block is skipped and the v-else legacy lobby
           renders instead. -->
      <video
        class="saudi-lobby-video"
        autoplay
        loop
        playsinline
        preload="auto"
        :key="saudiLobbyVideoUrl"
      >
        <source :src="saudiLobbyVideoUrl" type="video/mp4" />
      </video>
      <!-- Soft top + bottom vignette so the global top header chrome
           and the Enter button stay readable over any video frame. -->
      <div class="saudi-lobby-overlay" aria-hidden="true"></div>
  
      <!-- Logo slot - sits inside the top-left of the global header strip.
           The wrapper is fixed-positioned and rides above the v-app-bar
           background so it stays visible at every breakpoint. Lobby-only
           - other pages keep their banner image. -->
      <div class="saudi-lobby-logo" aria-label="Saudi - Welcome to Arabia">
        <img
          :src="require('@/assets/Images/saudi-brand-logo.svg')"
          alt="Saudi - Welcome to Arabia"
        />
      </div>
  
      <div class="saudi-lobby-content">
        <!-- Enter pill button - Figma node 36554:1189
             Default: translucent white with backdrop blur + white border.
             Hover : white-to-light-purple gradient + drop shadow.
             Width expands 300 -> 340px on hover (Figma variant). -->
        <button type="button" class="saudi-enter-btn" @click="onSaudiEnterClick">
          <span class="saudi-enter-btn-label">Enter</span>
          <span class="saudi-enter-btn-icon" aria-hidden="true">
            <svg
              width="64"
              height="64"
              viewBox="0 0 64 64"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                class="saudi-enter-btn-icon-ring"
                cx="32"
                cy="32"
                r="31"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
              />
              <path
                d="M28 22 L40 32 L28 42"
                stroke="currentColor"
                stroke-width="2.5"
                stroke-linecap="round"
                stroke-linejoin="round"
                fill="none"
              />
            </svg>
          </span>
        </button>
      </div>
  
      <!-- Hidden audio (kept from legacy lobby) so the music handlers
           in mounted() still resolve their DOM lookups without errors. -->
      <audio id="lobbyMusic" class="lobby-music d-none" loop autoplay />
    </div>

    <div v-else>
      <div style="background: white !important; height: 100vh">
        <div class="social-wall-right d-none">
          <a
            class="twitter-timeline mt-8 d-inline-block"
            href="https://twitter.com/tatnews_org?ref_src=twsrc%5Etfw"
            style="color: #000"
          ></a>
        </div>
        <v-row
          style="height: 100vh"
          align="center"
          justify="center"
          v-if="LobbyType == 0"
        >
          <v-progress-circular
            size="80"
            indeterminate
            color="primary"
          ></v-progress-circular
        ></v-row>
        <section
          v-show="LobbyType == 1"
          id="lobby_page"
          style="background-color: black"
          class="lobby-page active main-container-hld lobby-page-wrapper pt-3 pt-md-5 flex-column animated fadeIn;"
          :style="'background-image: url(' + LobbyBackground + ')'"
        >
          <div class="link-wrapper" style="display: none">
            <span class="back-link">
              <router-link to="/eventlist">{{ $t("lobby.back") }}</router-link>
            </span>
            <span class="logout-link" @click.prevent="clearstate">{{
              $t("lobby.logout")
            }}</span>
          </div>
          <div class="container-fluid page-effect">
            <div class="row tab-content h-100">
              <div
                id="sponsors"
                role="tabpanel"
                class="tab-pane fade col-lg-3 photowall-left-panel"
              >
                <div class="left-panel text-center d-flex flex-column h-100">
                  <div id="SponsorTopText" class="phtowall-top-box">
                    <h2 id="leftWallHeading" class="clssponsorText">
                      {{ $t("lobby.thankyou") }}
                    </h2>
  
                    <h3 class="text-uppercase support-text clssponsorText d-none">
                      {{ $t("lobby.tooursupporters") }}
                    </h3>
                  </div>
  
                  <div
                    id="sponsorPanel"
                    class="sponsors-hld mt-0 mt-lg-4 all-panel h-100 mb-md-0 mb-0"
                    :style="'border: 20px solid ' + leftPanelBordercolor"
                  >
                    <div class="d-lg-block sponsor-heading">
                      <span id="leftWallHeadingSub" class="heading">{{
                        $t("lobby.sponsors")
                      }}</span>
                    </div>
                    <div id="sponsor-slide" class="owl-carousel d-block">
                      <hooper
                        style="height: 445px"
                        :vertical="true"
                        :center-mode="true"
                        :auto-play="true"
                        :play-speed="leftPhotoScrollDelay"
                        :hover-pause="true"
                        :items-to-show="1"
                        :items-to-slide="1"
                        :transition="1000"
                      >
                        <slide
                          v-for="(slide, indx) in leftPanelPhotoArray"
                          :key="indx"
                          :index="indx"
                        >
                          <div class="item">
                            <span class="sub-heading">
                              <small>{{ slide.headerText }}</small>
                            </span>
                            <figure
                              v-for="(photo, indx2) in slide.photoList"
                              :key="indx2"
                              :index="indx2"
                              class="d-flex align-items-center justify-content-center"
                            >
                              <img :src="photo.imgUrl" />
                            </figure>
                          </div>
                        </slide>
                      </hooper>
                    </div>
                  </div>
                </div>
              </div>
              <div
                id="home"
                role="tabpanel"
                class="tab-pane fade in active col-lg-6 text-center photowall-main-panel px-mob-0"
                style="width: auto !important"
              >
                <div class="d-flex flex-column h-100 home_inner_wrapper">
                  <div class="center-panel lobby-page-header-panel">
                    <span id="wellcomeBody" class="centr-heading">
                      {{ $t("lobby.welcome") }}
                      <label id="userName">{{ Userlists }}</label>
                    </span>
                    <h2 class="event-name-div" style="font-size: 16px !important">
                      {{ EventName }}
                    </h2>
                    <h1 id="headerText" class>
                      {{ EventName }}
                    </h1>
  
                    <div class="timer-hld">
                      <div id="countDownText" class="countdown-outside">
                        <h5 id="TimerHeader">
                          {{ $t("lobby.theEventStartsIn") }}
                        </h5>
                        <div id="countDownText" class="countdown-timer">
                          <div class="counter-block">
                            <div>
                              <span id="countDays1" />
                              <span id="countDays2" />
                            </div>
                            <label>{{ $t("lobby.days") }}</label>
                          </div>
                          <div class="counter-block-dot" />
                          <div class="counter-block">
                            <div>
                              <span id="countHours1" />
                              <span id="countHours2" />
                            </div>
                            <label>{{ $t("lobby.hours") }}</label>
                          </div>
                          <div class="counter-block-dot" />
                          <div class="counter-block">
                            <div>
                              <span id="countMinutes1" />
                              <span id="countMinutes2" />
                            </div>
                            <label>{{ $t("lobby.minutes") }}</label>
                          </div>
                          <div class="counter-block-dot" />
                          <div class="counter-block">
                            <div>
                              <span id="countSeconds1" />
                              <span id="countSeconds2" />
                            </div>
                            <label>{{ $t("lobby.seconds") }}</label>
                          </div>
                        </div>
                      </div>
                      <div
                        id="myCounter"
                        class="counter-group"
                        style="display: none"
                      >
                        <div class="counter-block">
                          <div class="counter days">
                            <div class="number show n1 hundreds">0</div>
                            <div class="number show n1 tens">0</div>
                            <div class="number show n1 units">0</div>
                            <div class="number hidden-up n2 hundreds">0</div>
                            <div class="number hidden-up n2 tens">0</div>
                            <div class="number hidden-up n2 units">0</div>
                          </div>
                          <div class="counter-caption">
                            {{ $t("lobby.days") }}
                          </div>
                        </div>
                        <div class="counter-block">
                          <div class="bulet">
                            <span />
                            <span />
                          </div>
                          <div class="counter hours">
                            <div class="number show n1 tens">0</div>
                            <div class="number show n1 units">0</div>
                            <div class="number hidden-up n2 tens">0</div>
                            <div class="number hidden-up n2 units">0</div>
                          </div>
                          <div class="counter-caption">
                            {{ $t("lobby.hours") }}
                          </div>
                        </div>
                        <div class="counter-block">
                          <div class="bulet">
                            <span />
                            <span />
                          </div>
                          <div class="counter minutes">
                            <div class="number show n1 tens">0</div>
                            <div class="number show n1 units">0</div>
                            <div class="number hidden-up n2 tens">0</div>
                            <div class="number hidden-up n2 units">0</div>
                          </div>
                          <div class="counter-caption">
                            {{ $t("lobby.minutes") }}
                          </div>
                        </div>
                        <div class="counter-block">
                          <div class="counter seconds">
                            <div class="number show n1 tens">0</div>
                            <div class="number show n1 units">0</div>
                            <div class="number hidden-up n2 tens">0</div>
                            <div class="number hidden-up n2 units">0</div>
                          </div>
                          <div class="counter-caption">
                            {{ $t("lobby.seconds") }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      id="divGoToSite"
                      class="button-area text-center mt-md-4 mt-2 mb-2"
                      style="display: block"
                    >
                      <router-link
                        id="linkGoToSite"
                        :to="MainJoinButtonUrl"
                        class="btn join-now-btn"
                        style="max-width: 300px"
                      >
                        <p id="pJoinbuttonText" class="d-block m-0 py-2" />
                      </router-link>
                    </div>
                    <div id="hostedByDiv1" class="hostBy">
                      Hosted by :
                      <label id="hostedByLabel" />
                    </div>
  
                    <br />
                    <div
                      v-if="EnableSubButtons"
                      id="divEventBtns"
                      class="button-link-hld mt-4"
                      style
                    >
                      <div id="divBtns" class="row justify-content-center">
                        <div v-if="showLeftButton" class="col">
                          <router-link id="anchLeft" :to="leftbuttonRoute">
                            <div class="box-button-hld justify-content-center">
                              <span> </span>
                              {{ leftButtonText }}
                            </div>
                          </router-link>
                        </div>
                        <div v-if="showMiddleButton" class="col">
                          <router-link id="anchMiddle" :to="MiddleButtonRoute">
                            <div class="box-button-hld justify-content-center">
                              <span> </span>
                              {{ middleButtonText }}
                            </div>
                          </router-link>
                        </div>
                        <div v-if="showRightButton" class="col">
                          <router-link id="anchRight" :to="rightButtonRoute">
                            <div class="box-button-hld justify-content-center">
                              <span> </span>
                              {{ rightButtonText }}
                            </div>
                          </router-link>
                        </div>
                      </div>
                    </div>
                    <div id="hostedByDiv" class="hostBy">
                      Hosted by :
                      <label id="hostedByLabel" />
                    </div>
                  </div>
  
                  <div id="audioWrapper" class="audio-wrapper1 audio-vol-icon">
                    <div class="audio-control">
                      <button
                        id="loobyMusic_play"
                        type="button"
                        style="display: none"
                        @click="LobbyMusicUnmuted(this)"
                      >
                        <svg
                          version="1.1"
                          width="20px"
                          x="0px"
                          y="0px"
                          viewBox="0 0 506.24 506.24"
                          style="enable-background: new 0 0 506.24 506.24"
                          xml:space="preserve"
                        >
                          <g>
                            <g>
                              <g>
                                <path
                                  d="M432.56,318.56l29.68,11.936c4.315-10.739,7.714-21.824,10.16-33.136l-31.28-6.784
                                C439.054,300.127,436.191,309.488,432.56,318.56z"
                                />
                                <path
                                  d="M393.568,377.568l22.624,22.64c11.671-11.672,21.919-24.685,30.528-38.768l-27.2-16.672
                                C412.2,356.691,403.488,367.702,393.568,377.568z"
                                />
                                <rect
                                  x="253.12"
                                  y="333.12"
                                  width="32"
                                  height="32"
                                />
                                <path
                                  d="M488.432,40.432l-22.624-22.624L285.12,198.496V0l-166.4,157.12h-89.6v192h89.6l8.08,7.648L17.808,465.808l22.624,22.624
                                l109.696-109.696L285.12,506.24V397.12h-32V432l-80.368-75.888l80.368-80.368v25.376h32v-57.376l57.6-57.6
                                c33.278,44.566,28.844,106.794-10.416,146.192l22.624,22.624c51.751-51.895,56.328-134.359,10.64-191.664l31.136-31.136
                                c31.132,32.569,48.478,75.905,48.416,120.96c0,2.816-0.08,5.616-0.208,8.432l32,1.472c0.208-3.296,0.208-6.608,0.208-9.904
                                c0.094-53.551-20.629-105.043-57.792-143.6L488.432,40.432z M253.12,230.496L149.488,334.128L131.52,317.12h-70.4v-128h70.4
                                l121.6-114.88V230.496z"
                                />
                              </g>
                            </g>
                          </g>
                        </svg>
                      </button>
                      <button
                        id="loobyMusic_pause"
                        type="button"
                        @click="LobbyMusicMuted(this)"
                      >
                        <svg
                          id="Capa_1"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          x="0px"
                          y="0px"
                          width="20px"
                          viewBox="0 0 480 480"
                          style="enable-background: new 0 0 480 480"
                          xml:space="preserve"
                        >
                          <path
                            d="M278.944,17.577c-5.568-2.656-12.128-1.952-16.928,1.92L106.368,144.009H32c-17.632,0-32,14.368-32,32v128
                            c0,17.664,14.368,32,32,32h74.368l155.616,124.512c2.912,2.304,6.464,3.488,10.016,3.488c2.368,0,4.736-0.544,6.944-1.6
                            c5.536-2.656,9.056-8.256,9.056-14.4v-416C288,25.865,284.48,20.265,278.944,17.577z"
                          />
                          <path
                            d="M368.992,126.857c-6.304-6.208-16.416-6.112-22.624,0.128c-6.208,6.304-6.144,16.416,0.128,22.656
                            C370.688,173.513,384,205.609,384,240.009s-13.312,66.496-37.504,90.368c-6.272,6.176-6.336,16.32-0.128,22.624
                            c3.136,3.168,7.264,4.736,11.36,4.736c4.064,0,8.128-1.536,11.264-4.64C399.328,323.241,416,283.049,416,240.009
                            S399.328,156.777,368.992,126.857z"
                          />
                          <path
                            d="M414.144,81.769c-6.304-6.24-16.416-6.176-22.656,0.096c-6.208,6.272-6.144,16.416,0.096,22.624
                            C427.968,140.553,448,188.681,448,240.009s-20.032,99.424-56.416,135.488c-6.24,6.24-6.304,16.384-0.096,22.656
                            c3.168,3.136,7.264,4.704,11.36,4.704c4.064,0,8.16-1.536,11.296-4.64C456.64,356.137,480,299.945,480,240.009
                            S456.64,123.881,414.144,81.769z"
                          />
                          <g />
                        </svg>
                      </button>
                    </div>
  
                    <div
                      style="
                        position: relative;
                        height: 22px;
                        width: 22px;
                        overflow: hidden;
                        border-radius: 50%;
                        margin: auto;
                        top: 8px;
                        display: none;
                      "
                    >
                      <audio id="lobbyMusic" class="lobby-music" loop autoplay />
                    </div>
                  </div>
                </div>
                <section class="video-hld pt-0 pt-lg-5 d-none">
                  <div class="container-fluid">
                    <div class="row no-gutters">
                      <div class="col-lg-8 mx-auto">
                        <div class="video-container">
                          <div class="embed-responsive embed-responsive-16by9">
                            <video
                              id="video"
                              class="embed-responsive-item"
                              controls
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
  
                <div class="mobile_main_lobby d-block d-md-none">
                  <div class="mob_lobby_top_part">
                    <span id="wellcomeBody" class="centr-heading">
                      {{ $t("lobby.welcome") }}
                      <label id="userName">{{ Userlists }}</label>
                    </span>
                  </div>
  
                  <div class="mob_lobby_link_wrapper">
                    <div class="d-flex flex-wrap mob_lobby_link_wrapper_inner">
                      <div
                        class="lobby_link_box"
                        v-for="mobile in mobileLobbyMenu"
                        :key="mobile.MenuID"
                      >
                        <div
                          class="lobby_ico_box"
                          @click="goToPageFromMobileMenu(mobile.PageUrl)"
                        >
                          <img
                            v-if="mobile.Name == 'OneToOneMeeting'"
                            src="../assets/Images/icons/Mobile_lobby_icon/home_1_1_meeting.png"
                            alt="icon"
                          />
                          <img
                            v-if="mobile.Name == 'Attendees'"
                            src="../assets/Images/icons/Mobile_lobby_icon/home_attendees.png"
                            alt="icon"
                          />
  
                          <img
                            v-if="mobile.Name == 'Exhibitors'"
                            src="../assets/Images/icons/Mobile_lobby_icon/home_exhibits.png"
                            alt="icon"
                          />
  
                          <img
                            v-if="mobile.Name == 'Leaderboard'"
                            src="../assets/Images/icons/Mobile_lobby_icon/home_leaderboard.png"
                            alt="icon"
                          />
                          <img
                            v-if="
                              mobile.Name == 'Live Stage' ||
                              mobile.Name == 'Sessions'
                            "
                            src="../assets/Images/icons/Mobile_lobby_icon/home_live_stage.png"
                            alt="icon"
                          />
  
                          <img
                            v-if="mobile.Name == 'Resources'"
                            src="../assets/Images/icons/Mobile_lobby_icon/home_resources.png"
                            alt="icon"
                          />
                          <img
                            v-if="mobile.Name == 'RoundTables'"
                            src="../assets/Images/icons/Mobile_lobby_icon/home_roundtable.png"
                            alt="icon"
                          />
                          <img
                            v-if="mobile.Name == 'Social Wall'"
                            src="../assets/Images/icons/Mobile_lobby_icon/home_social_wall.png"
                            alt="icon"
                          />
                          <img
                            v-if="mobile.Name == 'Speakers'"
                            src="../assets/Images/icons/Mobile_lobby_icon/home_speakers.png"
                            alt="icon"
                          />
  
                          <img
                            v-if="mobile.Name == 'Sponsors'"
                            src="../assets/Images/icons/Mobile_lobby_icon/home_sponsors.png"
                            alt="icon"
                          />
  
                          <img
                            v-if="mobile.Name == 'Info'"
                            src="../assets/Images/icons/Mobile_lobby_icon/home_help_chat.png"
                            alt="icon"
                          />
                        </div>
                        <p>{{ mobile.DisplayLabel }}</p>
                      </div>
                    </div>
                  </div>
                  <div
                    id="audioWrapper_mobile"
                    class="audio-wrapper1 audio-vol-icon"
                  >
                    <div class="audio-control">
                      <button
                        id="loobyMusic_play_mobile"
                        type="button"
                        style="display: none"
                        @click="LobbyMusicUnmuted(this)"
                      >
                        <svg
                          version="1.1"
                          width="20px"
                          x="0px"
                          y="0px"
                          viewBox="0 0 506.24 506.24"
                          style="enable-background: new 0 0 506.24 506.24"
                          xml:space="preserve"
                        >
                          <g>
                            <g>
                              <g>
                                <path
                                  d="M432.56,318.56l29.68,11.936c4.315-10.739,7.714-21.824,10.16-33.136l-31.28-6.784
                                C439.054,300.127,436.191,309.488,432.56,318.56z"
                                />
                                <path
                                  d="M393.568,377.568l22.624,22.64c11.671-11.672,21.919-24.685,30.528-38.768l-27.2-16.672
                                C412.2,356.691,403.488,367.702,393.568,377.568z"
                                />
                                <rect
                                  x="253.12"
                                  y="333.12"
                                  width="32"
                                  height="32"
                                />
                                <path
                                  d="M488.432,40.432l-22.624-22.624L285.12,198.496V0l-166.4,157.12h-89.6v192h89.6l8.08,7.648L17.808,465.808l22.624,22.624
                                l109.696-109.696L285.12,506.24V397.12h-32V432l-80.368-75.888l80.368-80.368v25.376h32v-57.376l57.6-57.6
                                c33.278,44.566,28.844,106.794-10.416,146.192l22.624,22.624c51.751-51.895,56.328-134.359,10.64-191.664l31.136-31.136
                                c31.132,32.569,48.478,75.905,48.416,120.96c0,2.816-0.08,5.616-0.208,8.432l32,1.472c0.208-3.296,0.208-6.608,0.208-9.904
                                c0.094-53.551-20.629-105.043-57.792-143.6L488.432,40.432z M253.12,230.496L149.488,334.128L131.52,317.12h-70.4v-128h70.4
                                l121.6-114.88V230.496z"
                                />
                              </g>
                            </g>
                          </g>
                        </svg>
                      </button>
                      <button
                        id="loobyMusic_pause_mobile"
                        type="button"
                        @click="LobbyMusicMuted(this)"
                      >
                        <svg
                          id="Capa_1"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          x="0px"
                          y="0px"
                          width="20px"
                          viewBox="0 0 480 480"
                          style="enable-background: new 0 0 480 480"
                          xml:space="preserve"
                        >
                          <path
                            d="M278.944,17.577c-5.568-2.656-12.128-1.952-16.928,1.92L106.368,144.009H32c-17.632,0-32,14.368-32,32v128
                            c0,17.664,14.368,32,32,32h74.368l155.616,124.512c2.912,2.304,6.464,3.488,10.016,3.488c2.368,0,4.736-0.544,6.944-1.6
                            c5.536-2.656,9.056-8.256,9.056-14.4v-416C288,25.865,284.48,20.265,278.944,17.577z"
                          />
                          <path
                            d="M368.992,126.857c-6.304-6.208-16.416-6.112-22.624,0.128c-6.208,6.304-6.144,16.416,0.128,22.656
                            C370.688,173.513,384,205.609,384,240.009s-13.312,66.496-37.504,90.368c-6.272,6.176-6.336,16.32-0.128,22.624
                            c3.136,3.168,7.264,4.736,11.36,4.736c4.064,0,8.128-1.536,11.264-4.64C399.328,323.241,416,283.049,416,240.009
                            S399.328,156.777,368.992,126.857z"
                          />
                          <path
                            d="M414.144,81.769c-6.304-6.24-16.416-6.176-22.656,0.096c-6.208,6.272-6.144,16.416,0.096,22.624
                            C427.968,140.553,448,188.681,448,240.009s-20.032,99.424-56.416,135.488c-6.24,6.24-6.304,16.384-0.096,22.656
                            c3.168,3.136,7.264,4.704,11.36,4.704c4.064,0,8.16-1.536,11.296-4.64C456.64,356.137,480,299.945,480,240.009
                            S456.64,123.881,414.144,81.769z"
                          />
                          <g />
                        </svg>
                      </button>
                    </div>
  
                    <div
                      style="
                        position: relative;
                        height: 22px;
                        width: 22px;
                        overflow: hidden;
                        border-radius: 50%;
                        margin: auto;
                        top: 8px;
                        display: none;
                      "
                    >
                      <audio class="lobby-music_mobile" loop autoplay />
                    </div>
                  </div>
                </div>
              </div>
              <div
                id="photowall"
                role="tabpanel"
                class="tab-pane fade col-lg-3 photowall-right-panel"
              >
                <div class="right-panel d-flex flex-column h-100 text-center">
                  <div id="PhotoWallTopText" class="phtowall-top-box">
                    <h2 id="rightWallHeading" class="clsPhotoText">
                      {{ $t("lobby.photowall") }}
                    </h2>
                  </div>
                  <div
                    id="divProfileContanier1"
                    class="profile-hld mt-4"
                    :style="'border: 20px solid ' + rightPanelBordercolor"
                  >
                    <div class="profile-contanier1">
                      <div class="d-lg-block sponsor-heading">
                        <span
                          id="rightWallHeadingSub"
                          class="heading photowallHed"
                        />
                      </div>
                      <div
                        id="divProfileItemsWrap1"
                        class="carousel1 vert slide mt-3"
                        data-ride="carousel"
                      >
                        <hooper
                          style="height: 445px"
                          :vertical="true"
                          :center-mode="true"
                          :auto-play="true"
                          :play-speed="rightPhotoScrollDelay"
                          :hover-pause="true"
                          :items-to-show="1"
                          :items-to-slide="1"
                          :transition="1000"
                        >
                          <slide
                            v-for="(slide2, indx) in rightPanelPhotoArray"
                            :key="indx"
                            :index="indx"
                          >
                            <div id="dvRightPanelItem" class="item">
                              <span class="sub-heading">
                                <small>{{ slide2.headerText }}</small>
                              </span>
                              <figure
                                v-for="(photo2, indx2) in slide2.rightPhotoList"
                                :key="indx2"
                                :index="indx2"
                              >
                                <img :src="photo2.imgUrl" />
                              </figure>
                            </div>
                          </slide>
                        </hooper>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
  
            <div
              class="mobile-tab-hld d-lg-none"
              style="display: none !important"
            >
              <ul class="nav nav-tabs row no-gutters" role="tablist">
                <li
                  id="leftTab"
                  class="nav-item col d-flex align-items-center justify-content-center"
                >
                  <a
                    id="sponsor"
                    class="nav-link"
                    href="#sponsors"
                    role="tab"
                    data-toggle="tab"
                  >
                    <span class="tab-sponsors" />{{ $t("lobby.sponsors") }}
                  </a>
                </li>
                <li
                  id="mainTab"
                  class="nav-item col d-flex align-items-center justify-content-center"
                >
                  <a
                    id="home1"
                    class="nav-link active"
                    href="#home"
                    role="tab"
                    data-toggle="tab"
                  >
                    <span class="tab-home" />{{ $t("lobby.home") }}
                  </a>
                </li>
                <li
                  id="rightTab"
                  class="nav-item col d-flex align-items-center justify-content-center"
                >
                  <a
                    id="photo-wall"
                    class="nav-link"
                    href="#photowall"
                    role="tab"
                    data-toggle="tab"
                  >
                    <span class="photo-wall" />{{ $t("lobby.photowall") }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </section>
        <section
          v-if="LobbyType == 2"
          id="dvlobby"
          class="d-flex lobby-page-wrapper lobby-img-hld-main position-relative"
          style="justify-content: center; background: #000"
        >
          <div class="lobby-leader-board-panel" v-if="enableLobbyLeaderboard">
            <div class="lobby-leaderboard-header">
              <h3>
                <img
                  src="../assets/Images/lobby-leaderboard/leaderboard-icon.png"
                />
                <span>Leaderboard</span>
              </h3>
            </div>
            <div class="lobby-leaderboard-inner-section">
              <LeaderBoardComponent></LeaderBoardComponent>
            </div>
          </div>
          <div class="link-wrapper" style="display: none">
            <span class="back-link">
              <router-link to="/eventlist">{{ $t("lobby.back") }}</router-link>
            </span>
            <span class="logout-link" @click.prevent="clearstate">{{
              $t("lobby.logout")
            }}</span>
          </div>
          <div
            v-if="isMusicEnabled"
            id="audioWrapper"
            class="audio-wrapper1 audio-vol-icon"
            style="z-index: 9999"
          >
            <div class="audio-control">
              <button
                id="loobyMusic_play1"
                type="button"
                style="display: none"
                @click="LobbyMusicUnmuted(this)"
              >
                <svg
                  version="1.1"
                  width="20px"
                  x="0px"
                  y="0px"
                  viewBox="0 0 506.24 506.24"
                  style="enable-background: new 0 0 506.24 506.24"
                  xml:space="preserve"
                >
                  <g>
                    <g>
                      <g>
                        <path
                          d="M432.56,318.56l29.68,11.936c4.315-10.739,7.714-21.824,10.16-33.136l-31.28-6.784
                                C439.054,300.127,436.191,309.488,432.56,318.56z"
                        />
                        <path
                          d="M393.568,377.568l22.624,22.64c11.671-11.672,21.919-24.685,30.528-38.768l-27.2-16.672
                                C412.2,356.691,403.488,367.702,393.568,377.568z"
                        />
                        <rect x="253.12" y="333.12" width="32" height="32" />
                        <path
                          d="M488.432,40.432l-22.624-22.624L285.12,198.496V0l-166.4,157.12h-89.6v192h89.6l8.08,7.648L17.808,465.808l22.624,22.624
                                l109.696-109.696L285.12,506.24V397.12h-32V432l-80.368-75.888l80.368-80.368v25.376h32v-57.376l57.6-57.6
                                c33.278,44.566,28.844,106.794-10.416,146.192l22.624,22.624c51.751-51.895,56.328-134.359,10.64-191.664l31.136-31.136
                                c31.132,32.569,48.478,75.905,48.416,120.96c0,2.816-0.08,5.616-0.208,8.432l32,1.472c0.208-3.296,0.208-6.608,0.208-9.904
                                c0.094-53.551-20.629-105.043-57.792-143.6L488.432,40.432z M253.12,230.496L149.488,334.128L131.52,317.12h-70.4v-128h70.4
                                l121.6-114.88V230.496z"
                        />
                      </g>
                    </g>
                  </g>
                </svg>
              </button>
              <button
                id="loobyMusic_pause1"
                type="button"
                @click="LobbyMusicMuted(this)"
              >
                <svg
                  id="Capa_1"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  width="20px"
                  viewBox="0 0 480 480"
                  style="enable-background: new 0 0 480 480"
                  xml:space="preserve"
                >
                  <path
                    d="M278.944,17.577c-5.568-2.656-12.128-1.952-16.928,1.92L106.368,144.009H32c-17.632,0-32,14.368-32,32v128
                            c0,17.664,14.368,32,32,32h74.368l155.616,124.512c2.912,2.304,6.464,3.488,10.016,3.488c2.368,0,4.736-0.544,6.944-1.6
                            c5.536-2.656,9.056-8.256,9.056-14.4v-416C288,25.865,284.48,20.265,278.944,17.577z"
                  />
                  <path
                    d="M368.992,126.857c-6.304-6.208-16.416-6.112-22.624,0.128c-6.208,6.304-6.144,16.416,0.128,22.656
                            C370.688,173.513,384,205.609,384,240.009s-13.312,66.496-37.504,90.368c-6.272,6.176-6.336,16.32-0.128,22.624
                            c3.136,3.168,7.264,4.736,11.36,4.736c4.064,0,8.128-1.536,11.264-4.64C399.328,323.241,416,283.049,416,240.009
                            S399.328,156.777,368.992,126.857z"
                  />
                  <path
                    d="M414.144,81.769c-6.304-6.24-16.416-6.176-22.656,0.096c-6.208,6.272-6.144,16.416,0.096,22.624
                            C427.968,140.553,448,188.681,448,240.009s-20.032,99.424-56.416,135.488c-6.24,6.24-6.304,16.384-0.096,22.656
                            c3.168,3.136,7.264,4.704,11.36,4.704c4.064,0,8.16-1.536,11.296-4.64C456.64,356.137,480,299.945,480,240.009
                            S456.64,123.881,414.144,81.769z"
                  />
                  <g />
                </svg>
              </button>
            </div>
  
            <div
              style="
                position: absolute;
                height: 100%;
                width: 100%;
                overflow: hidden;
                border-radius: 50%;
                margin: auto;
                top: 50%;
                display: block;
                left: 50%;
                transform: translate(-50%, -50%);
                z-index: -1;
              "
            >
              <audio class="lobby-music" loop autoplay :src="LobbyMusicURL" />
            </div>
          </div>
          <div
            v-if="customHtml"
            :class="
              turnONOFFPointer == false
                ? 'virtual-lobby-image test'
                : 'virtual-lobby-image'
            "
            style="display: inline-block; position: relative; overflow: auto"
            v-html="customHtml"
          ></div>
          <div v-else-if="!isLoading">Custom HTML not Supplied</div>
        </section>
  
        <v-dialog v-model="showLobbyPopup" class="chat-dialog" width="1200">
          <v-card height="80vh" style="overflow: hidden">
            <v-card-actions
              class="d-flex justify-content-between allign-items-center"
            >
              <div class="chess-user-guide-wrap">
                <ul>
                  <li>
                    <h3 class="mb-0">
                      <span>1</span> Read The {{ lobbyPopupHeader }}
                    </h3>
                  </li>
                  <li>
                    <h3 class="mb-0 mr-5">
                      <span>2</span> Don't Forget To Upload Your Profile Picture.
                      <a href="/myprofile" target="_blank">Click Here</a>
                    </h3>
                  </li>
                </ul>
              </div>
              <div class="close-action">
                <v-icon
                  dark
                  size="20"
                  color="#333"
                  @click="showLobbyPopup = false"
                  >mdi-close</v-icon
                >
              </div>
            </v-card-actions>
            <div class="open-section px-3" v-if="lobbyPopupType == 'PDF'">
              <iframe width="100%" :src="lobbyPopupResourceUrl"> </iframe>
            </div>
          </v-card>
        </v-dialog>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
/* =====================================================================
   Saudi lobby splash - Figma frame 36554:1188 (Enter button), shown
   centered over a full-screen autoplay video background.

   Layout strategy:
   - .saudi-lobby is a 100vh viewport-bound wrapper. The video lives
     behind everything (object-fit: cover keeps it full-bleed at any
     aspect ratio).
   - .saudi-lobby-overlay is a soft gradient mask so the global top
     header (rendered in App.vue's v-app-bar) stays readable and the
     bottom of the video gently fades behind the Enter button.
   - .saudi-lobby-content holds the Enter button and is anchored to
     the bottom-center of the frame so the button sits clear of the
     header chrome above and aligns with the Figma layout.
===================================================================== */
.saudi-lobby {
  /* Fixed-position wrapper so the video covers the entire viewport
     regardless of v-main's top padding (which Vuetify adds for the
     `app` v-app-bar). The header renders above this at z-index 1004,
     so the Enter button + video stay edge-to-edge underneath. */
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background: #000;
  z-index: 0;
}
.saudi-lobby .saudi-lobby-video {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  z-index: 0;
  pointer-events: none;
}
.saudi-lobby .saudi-lobby-overlay {
  position: absolute;
  inset: 0;
  z-index: 1;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.35) 0%,
    rgba(0, 0, 0, 0) 18%,
    rgba(0, 0, 0, 0) 60%,
    rgba(0, 0, 0, 0.45) 100%
  );
  pointer-events: none;
}
.saudi-lobby .saudi-lobby-content {
  position: absolute;
  inset: 0;
  z-index: 2;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding: 0 24px 80px;
  pointer-events: none;
}
.saudi-lobby .saudi-lobby-content > * {
  pointer-events: auto;
}

/* ---------------------------------------------------------------------
   Logo slot. Pinned to the top-left and sits ABOVE the v-app-bar
   (which is at z-index 1004 on mobile, default on desktop) so the
   logo always renders on top of the dark glass header strip. The
   existing chat / notification / profile icons live inside the
   v-app-bar on the right - we don't touch them here, only add a
   left-side placeholder for the lobby brand mark.
--------------------------------------------------------------------- */
.saudi-lobby .saudi-lobby-logo {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1200;
  display: inline-flex;
  align-items: center;
  height: 64px;
  padding: 8px 24px;
  pointer-events: none;
  width: 100%;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.8) 0%,
    rgba(0, 0, 0, 0) 100%
  );
}
.saudi-lobby .saudi-lobby-logo img,
.saudi-lobby .saudi-lobby-logo svg {
  display: block;
  max-height: 48px;
  width: auto;
  pointer-events: auto;
}
/* Visible placeholder while no real logo asset is wired in. Renders
   as a soft outlined chip on the dark glass strip so the slot is
   immediately discoverable - drop a real <img> in the template above
   and this span can be deleted. */
.saudi-lobby .saudi-lobby-logo .saudi-lobby-logo-placeholder {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  min-width: 96px;
  padding: 0 16px;
  border: 1px dashed rgba(255, 255, 255, 0.6);
  border-radius: 8px;
  color: rgba(255, 255, 255, 0.85);
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  background: rgba(255, 255, 255, 0.08);
  -webkit-backdrop-filter: blur(4px);
  backdrop-filter: blur(4px);
  pointer-events: auto;
}

@media (max-width: 767px) {
  .saudi-lobby .saudi-lobby-logo {
    height: 56px;
    padding: 6px 14px;
  }
  .saudi-lobby .saudi-lobby-logo img,
  .saudi-lobby .saudi-lobby-logo svg {
    max-height: 40px;
  }
  .saudi-lobby .saudi-lobby-logo .saudi-lobby-logo-placeholder {
    height: 32px;
    min-width: 72px;
    font-size: 12px;
  }
}

/* ---------------------------------------------------------------------
   Enter button - Figma 36554:1188 (Default) / 36554:1190 (Hover)
   Default : 300px wide, rgba(255,255,255,0.6) bg, 2px white border,
             backdrop-blur 12px, pill (radius 999px), Inter Medium 40px.
   Hover   : 340px wide, gradient #fff -> #ebd5fb (left), filled circle
             arrow icon, drop-shadow 0 4 7 rgba(0,0,0,0.35).
   The :deep selectors are not needed - the button is in this file's
   own template so plain scoped selectors target it.
--------------------------------------------------------------------- */
.saudi-lobby .saudi-enter-btn {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  width: 300px;
  padding: 18px 30px 18px 50px;
  border-radius: 999px;
  border: 2px solid rgba(255, 255, 255, 0.6);
  background: rgba(255, 255, 255, 0.6);
  -webkit-backdrop-filter: blur(12px);
  backdrop-filter: blur(12px);
  color: #000000;
  font-family: "Inter", sans-serif;
  font-size: 40px;
  font-weight: 500;
  line-height: 40px;
  cursor: pointer;
  transition: width 0.28s ease, background 0.28s ease, box-shadow 0.28s ease,
    transform 0.28s ease;
  /* Reset native button chrome */
  outline: 0;
  -webkit-appearance: none;
  appearance: none;
}
.saudi-lobby .saudi-enter-btn:focus-visible {
  outline: 2px solid #cd1580;
  outline-offset: 4px;
}
.saudi-lobby .saudi-enter-btn .saudi-enter-btn-label {
  flex: 1 1 auto;
  text-align: left;
  white-space: nowrap;
}
.saudi-lobby .saudi-enter-btn .saudi-enter-btn-icon {
  flex: 0 0 64px;
  width: 64px;
  height: 64px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #000;
  border-radius: 50%;
  transition: background 0.28s ease, color 0.28s ease;
}
.saudi-lobby .saudi-enter-btn .saudi-enter-btn-icon svg {
  width: 100%;
  height: 100%;
  display: block;
}

/* Hover state - swap to gradient + dark filled chevron circle.
   The icon ring goes transparent and the icon background becomes
   #000 with white chevron, matching `arrow-circle-right-hover`
   from Figma. */
.saudi-lobby .saudi-enter-btn:hover,
.saudi-lobby .saudi-enter-btn:focus-visible {
  width: 340px;
  background: linear-gradient(to left, #ffffff 0%, #ebd5fb 100%);
  border-color: rgba(255, 255, 255, 0.9);
  box-shadow: 0 4px 7px rgba(0, 0, 0, 0.35);
}
.saudi-lobby .saudi-enter-btn:hover .saudi-enter-btn-icon,
.saudi-lobby .saudi-enter-btn:focus-visible .saudi-enter-btn-icon {
  background: #000000;
  color: #ffffff;
}
.saudi-lobby .saudi-enter-btn:hover .saudi-enter-btn-icon-ring,
.saudi-lobby .saudi-enter-btn:focus-visible .saudi-enter-btn-icon-ring {
  stroke: transparent;
}

/* Tablet + phone - tighten the button proportions so it doesn't run
   off-screen, but keep the same visual language. */
@media (max-width: 767px) {
  .saudi-lobby .saudi-lobby-content {
    padding: 0 20px 48px;
  }
  .saudi-lobby .saudi-enter-btn {
    width: 240px;
    padding: 12px 18px 12px 32px;
    font-size: 28px;
    line-height: 28px;
  }
  .saudi-lobby .saudi-enter-btn:hover,
  .saudi-lobby .saudi-enter-btn:focus-visible {
    width: 270px;
  }
  .saudi-lobby .saudi-enter-btn .saudi-enter-btn-icon {
    flex-basis: 44px;
    width: 44px;
    height: 44px;
  }
}

.main-container-hld .profile-hld {
  border: 24px solid transparent;
}
.countdown-timer {
  display: flex;
  justify-content: center;
}
.counter-block-dot {
  width: 20px;
  text-align: center;
  position: relative;
  flex-direction: column;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 0 39px 4px;
}
.counter-block-dot:after,
.counter-block-dot:before {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #fff;
  content: "";
  display: block;
  margin: 6px 0;
}
.counter-block {
  white-space: nowrap;
  width: 100px;
}
// .counter-block > div{
//   margin:10px;
// }
.counter-block span {
  font-size: 42px;
  line-height: 40px;
  color: #08385f;
  font-weight: bold;
  text-shadow: 1px 1px 2px #fff;
  background: #fff;
  margin: 2px;
  width: 48%;
  display: inline-block;
  border-radius: 7px;
  padding: 17px 0;
}
.counter-block label {
  display: block;
  font-size: 15px;
  line-height: 1;
  margin: 0;
  padding: 7px 0;
  color: #fff;
  letter-spacing: 0.2px;
}
</style>

////import carousel from "vue-owl-carousel"; ////export default { ////
//components: { carousel } ////};

<script>
import { Hooper, Slide } from "hooper";
import "hooper/dist/hooper.css";
import db from "../components/firebaseInit";
import store from "../store";
import router from "../router";
import jQuery from "jquery";
let $ = jQuery;
import eventsubscribe from "@/components/EventSubscribe";
import axios from "axios";
import APIs from "@/components/APIInit";
import common from "@/common";

import { bus } from "@/main";

import LeaderBoardComponent from "@/views/LeaderBoardComponent.vue";

//var fb_collectionName = "OA_UAT_C1591205467009E1591206650065";
//var photoWallItems = [];
var photoWallItemIdsLeft = [];
var photoWallItemIdsRight = [];

let eventSettingsQuery;
let photoWallQueryLeft;
let photoWallQueryRight;

//var carousel;
var vm;
var self;
export default {
  name: "App",
  components: {
    Hooper,
    Slide,
    LeaderBoardComponent,
  },
  data() {
    return {
      /* showSaudiSplash toggles the lobby template:
           true  -> Saudi video splash + Enter button (current default)
           false -> legacy lobby layout (photowall carousel via
                    Hooper/Slide + lobby leaderboard via
                    LeaderBoardComponent + sponsor panels).
         The legacy template is preserved in this file and rendered
         when this flag is false, so all the original components and
         their functionality are reachable at any time. */
      showSaudiSplash: true,
      enableLobbyLeaderboard: false,
      chatRoomId: null,
      showLobbyPopup: false,
      lobbyPopupType: null,
      lobbyPopupHeader: null,
      lobbyPopupResourceUrl: null,
      videoPlaySettings: null,
      IsLandscape: true,
      landscapeBGurl: "",
      portraitBGurl: "",
      // LobbyBackground: "",
      MainJoinButtonUrl: "/sessions",
      leftPanelBordercolor: "green",
      leftPhotoScrollDelay: 3000,
      rightPanelBordercolor: "green",
      rightPhotoScrollDelay: 3000,

      leftPanelPhotoArray: [],
      rightPanelPhotoArray: [],
      leftbuttonRoute: "",
      leftButtonText: "",
      MiddleButtonRoute: "",
      middleButtonText: "",
      rightButtonRoute: "",
      rightButtonText: "",
      joinButtonText: "",
      EnableSubButtons: false,
      showLeftButton: false,
      showMiddleButton: false,
      showRightButton: false,

      eventStartTime: parseInt(new Date().getTime() * 1000),
      countDownMinutes: 30,
      autoSwitchPage: true,
      loginEnabled: true,
      photoWallChunkSize: 2,
      photoWallItemsLeft: [],
      photoWallItemsRight: [],
      eventColectionName: "",
      virtualLobby: [],
      LobbyMusicURL: "",
      photoDirectoryLeft: "",
      photoDirectoryRight: "",
      customHtml: "",
      saudiLobbyVideoUrl: "",
      LobbyType: 0,
      isMusicEnabled: false,
      APIs: APIs,
      turnONOFFPointer: false,
      visitor: false,
      mobileLobbyMenu: [],
      isLoading: true,
    };
  },
  computed: {
    Userlists() {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      return obj.user[0].fname;
    },
    EventName() {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      return obj.eventname;
    },

    LobbyBackground() {
      if (self.IsLandscape) {
        return self.getCDNUrl(self.landscapeBGurl);
      } else {
        if (screen.width < 768) {
          return self.getCDNUrl(self.landscapeBGurl);
        } else {
          return self.getCDNUrl(self.portraitBGurl);
        }
      }
    },
  },
  watch: {
    customHtml() {
      this.$nextTick(() => {
        this.enhanceLobbyVideos();
      });
    },
    saudiLobbyVideoUrl(val) {
      if (!val) return;
      this.$nextTick(() => {
        this.enhanceLobbyVideos();
      });
    },
  },
  created() {
    vm = this;
    self = this;
    self.visitor = self.isVisitor();
    common.toggleTopMenu(false);
    common.toggleLeftMenu(false);
    //$("#topmenu").hide();
    //$("#leftmenu").hide();

    self.detectScreenOrientation();
    /* Mark the body so global CSS can target the lobby route only.
       Used to: (a) paint a frosted-glass overlay on the v-app-bar so
       the header sits over the video instead of pushing the page
       content down, and (b) hide the banner image / menu pill in
       the existing header on /lobby. Cleared in beforeDestroy. */
    if (typeof document !== "undefined" && document.body) {
      document.body.classList.add("route-saudi-lobby");
    }
  },
  beforeDestroy() {
    if (typeof document !== "undefined" && document.body) {
      document.body.classList.remove("route-saudi-lobby");
    }
  },
  mounted() {
    //debugger;
    var data = {
      showUserWelcomeLoader: false,
    };

    bus.$emit("setUserWelcomeLoader", data);
    var obj = JSON.parse(window.localStorage.getItem("my-app"));
    if (screen.width < 768) {
      vm.getMobileMenus();
    }

    //-------------dynamic font selection --------------------------------------
    vm.getDynamicFont();
    document.title = "Lobby - " + obj.eventname;
    if (!self.visitor) {
      $("#btnRedirectValidUrl").click();
    }
    $("#btnAddUserView").click();
    if (obj.lobbyLoaded == false) {
      //$("#btnLoadMenu").click();
      store.commit("Lobbyloaded", true);
      //-----------ujiya spl bannerRedirect-----------------------
      /* self.bannerRedirectURL = "";
      document.getElementById("routerlnkBanner").href = "#";
      document.getElementById("routerlnkBanner").target = "";
      debugger;
      if (obj.EventBannerRedirect !== undefined) {
        if (obj.EventBannerRedirect.length > 0) {
          debugger;
          console.log("EventBannerRedirect store - " + obj.EventBannerRedirect);
          self.bannerRedirectURL = obj.EventBannerRedirect;
          document.getElementById("routerlnkBanner").href =
            obj.EventBannerRedirect;

          document.getElementById("routerlnkBanner").target = "_blank";
        }
      }*/
      //----------------------------------------------------------
    }
    //this.$root.LoadEvent();

    //debugger;
    //vm.getMeetingSettings();
    //ename:events.Name, estartdt:events.EventStartDate, eenddt:events.EventEndDate

    obj = JSON.parse(window.localStorage.getItem("my-app"));
    vm.eventStartTime = obj.eventsdate.seconds;

    // console.log("EventColName : " + obj.eventcollectionname);
    vm.eventColectionName = obj.eventcollectionname;

    if (obj.branding[0].favicon != undefined) {
      if (obj.branding[0].favicon != "") {
        var link =
          document.querySelector("link[rel*='icon']") ||
          document.createElement("link");
        link.type = "image/x-icon";
        link.rel = "shortcut icon";
        link.href = obj.branding[0].favicon;
        document.getElementsByTagName("head")[0].appendChild(link);
      }
    }
    vm.showLeftButton = false;
    vm.setOtherParams();
    vm.getAttendeeID();
    vm.featchEventInfo();
    vm.getAdvExpoStatus();
    vm.getEventInfo();
  },
  updated() {
    $("#groupchat").click(function () {
      if (vm.chatRoomId) {
        bus.$emit("enableHiddenChat");
        setTimeout(() => {
          bus.$emit("openPredefinedChat", vm.chatRoomId);
        }, 200);
      }
    });
    vm.linkToRouterPush();
    $.getScript("https://platform.twitter.com/widgets.js", function () {});
  },

  methods: {
    /**
     * Handler for the Saudi lobby splash "Enter" button. Always routes
     * to /sessions to match the legacy lobby's MainJoinButtonUrl
     * default.
     */
    onSaudiEnterClick() {
      this.$router.push("/sessions");
    },
    isIOSDevice() {
      var ua = navigator.userAgent || "";
      if (/iPad|iPhone|iPod/.test(ua)) return true;
      // iPadOS 13+ reports as MacIntel with touch points
      return navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
    },
    enhanceLobbyVideos() {
      // Scan both the legacy customHtml container AND the new Saudi
      // splash container so the iOS auto-mute + sound-toggle logic
      // applies in both flows (matches legacy behavior on .virtual-
      // lobby-image and preserves it for .saudi-lobby).
      var legacyContainer = document.querySelector(".virtual-lobby-image");
      var saudiContainer = document.querySelector(".saudi-lobby");
      var container = legacyContainer || saudiContainer;
      if (!container) return;

      var isIOS = this.isIOSDevice();

      var videoList = [];
      if (legacyContainer) {
        legacyContainer.querySelectorAll("video").forEach((v) => videoList.push(v));
      }
      if (saudiContainer) {
        saudiContainer.querySelectorAll("video").forEach((v) => videoList.push(v));
      }
      var videos = videoList;
      videos.forEach((video) => {
        if (video.dataset.lobbyEnhanced === "1") return;
        video.dataset.lobbyEnhanced = "1";

        // Desktop: try autoplay-with-sound (legacy behavior); if the
        // browser blocks the call (low MEI / no prior user gesture),
        // fall back to muted autoplay so the video still plays. This
        // covers the case where the video element mounts after the
        // initial page paint and the browser autoplay attribute
        // alone isn't enough to trigger playback.
        if (!isIOS) {
          var dp = video.play();
          if (dp && typeof dp.catch === "function") {
            dp.catch(() => {
              video.muted = true;
              video.setAttribute("muted", "");
              var dp2 = video.play();
              if (dp2 && typeof dp2.catch === "function") {
                dp2.catch(() => {});
              }
            });
          }
        }

        // Only force-mute on iOS where autoplay-with-sound is blocked.
        // Leave desktop browsers (e.g. Windows Chrome) untouched so they
        // continue to autoplay with sound as before.
        if (isIOS) {
          video.muted = true;
          video.defaultMuted = true;
          video.setAttribute("muted", "");
          video.setAttribute("autoplay", "");
          video.setAttribute("playsinline", "");
          video.setAttribute("webkit-playsinline", "");

          var playPromise = video.play();
          if (playPromise && typeof playPromise.catch === "function") {
            playPromise.catch(() => {});
          }

          var wrap = video.parentElement;
          if (!wrap || !wrap.classList.contains("vl-video-wrap")) {
            wrap = document.createElement("div");
            wrap.className = "vl-video-wrap";
            video.parentNode.insertBefore(wrap, video);
            wrap.appendChild(video);
          }

          if (wrap.querySelector(".vl-sound-toggle")) return;

          var btn = document.createElement("button");
          btn.type = "button";
          btn.className = "vl-sound-toggle";
          btn.setAttribute("aria-label", "Toggle sound");
          btn.innerHTML = this.getSoundIcon(true);
          btn.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            video.muted = !video.muted;
            btn.innerHTML = this.getSoundIcon(video.muted);
            if (!video.muted) {
              var p = video.play();
              if (p && typeof p.catch === "function") p.catch(() => {});
            }
          });
          wrap.appendChild(btn);
        }
      });

      if (!isIOS) return;

      // YouTube/Vimeo: only force mute on iOS so desktop keeps sound.
      var iframes = container.querySelectorAll("iframe");
      iframes.forEach((iframe) => {
        if (iframe.dataset.lobbyEnhanced === "1") return;
        var src = iframe.getAttribute("src") || "";
        if (!src) return;
        if (/youtube\.com|youtu\.be|vimeo\.com/i.test(src)) {
          iframe.dataset.lobbyEnhanced = "1";
          var sep = src.indexOf("?") >= 0 ? "&" : "?";
          var addParams = "";
          if (!/[?&]autoplay=/.test(src)) addParams += sep + "autoplay=1";
          if (!/[?&]mute=/.test(src) && !/[?&]muted=/.test(src)) {
            addParams +=
              (addParams ? "&" : sep) +
              (/vimeo\.com/i.test(src) ? "muted=1" : "mute=1");
          }
          if (!/[?&]playsinline=/.test(src)) {
            addParams += (addParams ? "&" : sep) + "playsinline=1";
          }
          if (addParams) iframe.setAttribute("src", src + addParams);
          if (
            !iframe.getAttribute("allow") ||
            !/autoplay/.test(iframe.getAttribute("allow"))
          ) {
            iframe.setAttribute(
              "allow",
              "autoplay; encrypted-media; picture-in-picture"
            );
          }
        }
      });
    },
    getSoundIcon(muted) {
      if (muted) {
        return '<svg viewBox="0 0 24 24"><path d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"/></svg>';
      }
      return '<svg viewBox="0 0 24 24"><path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/></svg>';
    },
    getEventInfo() {
      if (vm.eventColectionName) {
        db.collection(vm.eventColectionName)
          .doc("EventInfo")
          .get()
          .then((doc) => {
            if (doc.exists) {
              var data = doc.data();
              setTimeout(() => {
                if (data.StageViewChatPosition) {
                  if (
                    data.StageViewChatPosition.Left &&
                    data.StageViewChatPosition.Top &&
                    data.StageViewChatPosition.Height &&
                    data.StageViewChatPosition.Width
                  ) {
                    $(":root").css(
                      "--stage-chat-left",
                      data.StageViewChatPosition.Left + "%"
                    );
                    $(":root").css(
                      "--stage-chat-top",
                      data.StageViewChatPosition.Top + "%"
                    );
                    $(":root").css(
                      "--stage-chat-height",
                      data.StageViewChatPosition.Height + "%"
                    );
                    $(":root").css(
                      "--stage-chat-width",
                      data.StageViewChatPosition.Width + "%"
                    );
                  }
                }
                if (
                  vm.$store.getters.getStageViewChat ||
                  data.IsStageviewChatEanbled
                ) {
                  if (data.DefaultRoomId) {
                    bus.$emit(
                      "openPredefinedStageViewChat",
                      data.DefaultRoomId
                    );
                  }
                }
                if (data.IsLobbyLeaderboardEnabled) {
                  vm.enableLobbyLeaderboard = true;
                }
              }, 1500);
            }
          });
      }
    },
    getMobileMenus() {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));

      if (obj.eventcollectionname !== "") {
        db.collection(obj.eventcollectionname)
          .doc("AppMenu")
          .get()
          .then((doc) => {
            vm.mobileLobbyMenu = [];

            var data = doc.data();
            $.each(data.LobbyMenu, function (key, value) {
              console.log("key=======", key);
              var str1 = value.Name;
              var mainmenuURL;
              if (
                value.Name == "Lobby" &&
                vm.$store.state.DefaultLoginLandingPage == "/clientLobby"
              ) {
                mainmenuURL = "/mainlobby";
              }
              if (
                value.Name == "Sessions" &&
                vm.$store.state.eventDefaultSessionPage == "/session_cal"
              )
                mainmenuURL = "/session_cal";
              else if (
                value.Name == "Resources" &&
                vm.$store.state.eventDefaultSessionPage == "/session_cal"
              )
                mainmenuURL = "/tasks";
              else mainmenuURL = value.PageUrl;
              if (mainmenuURL === "") {
                mainmenuURL = "#" + str1;
              }
              if (str1[str1.length - 1] == ".") str1 = str1.slice(0, -1);
              var subMenu;
              if (value.SubMenu === undefined) {
                subMenu = [];
              } else {
                var str2 = subMenu.Name;
                if (str2[str2.length - 1] == ".") str2 = str2.slice(0, -1);
                subMenu.push({
                  rowDivId: "row" + str1,
                  Name: subMenu.Name,
                  IconUrl: self.getCDNUrl(subMenu.IconUrl),
                  PageUrl: subMenu.PageUrl,
                });
              }

              if (value.PageUrl !== "") {
                const menuExists = vm.mobileLobbyMenu.some(
                  (menu) => menu.MenuID === value.MenuID
                );
                if (!menuExists) {
                  vm.mobileLobbyMenu.push({
                    MenuID: value.MenuID,
                    IconUrl: vm.getCDNUrl(value.IconUrl),
                    PageUrl: mainmenuURL,
                    ExternalPageUrl: value.ExternalPageUrl,
                    DisplayOrder: value.DisplayOrder,
                    DisplayLabel: value.DisplayLabel,
                    DisplayLabel_fr:
                      value.DisplayLabel_fr == undefined
                        ? ""
                        : value.DisplayLabel_fr,
                    DisplayLabel_zh:
                      value.DisplayLabel_zh == undefined
                        ? ""
                        : value.DisplayLabel_zh,
                    DisplayLabel_de:
                      value.DisplayLabel_de == undefined
                        ? ""
                        : value.DisplayLabel_de,
                    SubMenu: subMenu,
                    RoomId: value.RoomId == undefined ? "" : value.RoomId,
                    tab: "",
                    Name: value.Name == undefined ? "" : value.Name,
                  });
                }
              }
            });
            if (vm.mobileLobbyMenu.length == 0) {
              vm.mobileLobbyMenu = [];
              vm.getAllMenus();
            }
          })
          .catch((error) => {
            console.log(error);
          });

        //self.getSettings();
      }
    },
    getAllMenus() {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));

      if (obj.eventcollectionname !== "") {
        db.collection(obj.eventcollectionname)
          .doc("Menu")
          .get()
          .then((doc) => {
            var data = doc.data();
            $.each(data.LeftMenu, function (key, value) {
              var str1 = value.Name;
              var mainmenuURL;
              if (
                value.Name == "Lobby" &&
                vm.$store.state.DefaultLoginLandingPage == "/clientLobby"
              ) {
                mainmenuURL = "/mainlobby";
              }
              if (
                value.Name == "Sessions" &&
                vm.$store.state.eventDefaultSessionPage == "/session_cal"
              )
                mainmenuURL = "/session_cal";
              else if (
                value.Name == "Resources" &&
                vm.$store.state.eventDefaultSessionPage == "/session_cal"
              )
                mainmenuURL = "/tasks";
              else mainmenuURL = value.PageUrl;
              if (mainmenuURL === "") {
                mainmenuURL = "#" + str1;
              }
              if (str1[str1.length - 1] == ".") str1 = str1.slice(0, -1);
              var subMenu;
              if (value.SubMenu === undefined) {
                subMenu = [];
              } else {
                var str2 = subMenu.Name;
                if (str2[str2.length - 1] == ".") str2 = str2.slice(0, -1);
                subMenu.push({
                  rowDivId: "row" + str1,
                  Name: subMenu.Name,
                  IconUrl: self.getCDNUrl(subMenu.IconUrl),
                  PageUrl: subMenu.PageUrl,
                });
              }

              if (value.PageUrl !== "" && value.Name != "Lobby") {
                const menuExists = vm.mobileLobbyMenu.some(
                  (menu) => menu.MenuID === value.MenuID
                );
                if (!menuExists) {
                  vm.mobileLobbyMenu.push({
                    MenuID: value.MenuID,
                    IconUrl: vm.getCDNUrl(value.IconUrl),
                    PageUrl: mainmenuURL,
                    ExternalPageUrl: value.ExternalPageUrl,
                    DisplayOrder: value.DisplayOrder,
                    DisplayLabel: value.DisplayLabel,
                    DisplayLabel_fr:
                      value.DisplayLabel_fr == undefined
                        ? ""
                        : value.DisplayLabel_fr,
                    DisplayLabel_zh:
                      value.DisplayLabel_zh == undefined
                        ? ""
                        : value.DisplayLabel_zh,
                    DisplayLabel_de:
                      value.DisplayLabel_de == undefined
                        ? ""
                        : value.DisplayLabel_de,
                    SubMenu: subMenu,
                    RoomId: value.RoomId == undefined ? "" : value.RoomId,
                    tab: "",
                    Name: value.Name == undefined ? "" : value.Name,
                  });
                }
              }
            });
            $.each(data.AllMenu, function (key, value) {
              var str1 = value.Name;
              var mainmenuURL;
              if (
                value.Name == "Lobby" &&
                vm.$store.state.DefaultLoginLandingPage == "/clientLobby"
              ) {
                mainmenuURL = "/mainlobby";
              }
              if (
                value.Name == "Sessions" &&
                vm.$store.state.eventDefaultSessionPage == "/session_cal"
              )
                mainmenuURL = "/session_cal";
              else if (
                value.Name == "Resources" &&
                vm.$store.state.eventDefaultSessionPage == "/session_cal"
              )
                mainmenuURL = "/tasks";
              else mainmenuURL = value.PageUrl;
              if (mainmenuURL === "") {
                mainmenuURL = "#" + str1;
              }
              if (str1[str1.length - 1] == ".") str1 = str1.slice(0, -1);
              var subMenu;
              if (value.SubMenu === undefined) {
                subMenu = [];
              } else {
                var str2 = subMenu.Name;
                if (str2[str2.length - 1] == ".") str2 = str2.slice(0, -1);
                subMenu.push({
                  rowDivId: "row" + str1,
                  Name: subMenu.Name,
                  IconUrl: self.getCDNUrl(subMenu.IconUrl),
                  PageUrl: subMenu.PageUrl,
                });
              }

              if (value.PageUrl !== "" && value.Name != "Lobby") {
                const menuExists = vm.mobileLobbyMenu.some(
                  (menu) => menu.MenuID === value.MenuID
                );

                if (!menuExists) {
                  vm.mobileLobbyMenu.push({
                    MenuID: value.MenuID,
                    IconUrl: vm.getCDNUrl(value.IconUrl),
                    PageUrl: mainmenuURL,
                    ExternalPageUrl: value.ExternalPageUrl,
                    DisplayOrder: value.DisplayOrder,
                    DisplayLabel: value.DisplayLabel,
                    DisplayLabel_fr:
                      value.DisplayLabel_fr == undefined
                        ? ""
                        : value.DisplayLabel_fr,
                    DisplayLabel_zh:
                      value.DisplayLabel_zh == undefined
                        ? ""
                        : value.DisplayLabel_zh,
                    DisplayLabel_de:
                      value.DisplayLabel_de == undefined
                        ? ""
                        : value.DisplayLabel_de,
                    SubMenu: subMenu,
                    RoomId: value.RoomId == undefined ? "" : value.RoomId,
                    tab: "",
                    Name: value.Name == undefined ? "" : value.Name,
                  });
                }
              }
            });
          });
      }
    },
    goToPageFromMobileMenu(url) {
      vm.$router.push(url);
    },
    getCookie(cname) {
      var name = cname + "=";
      var decodedCookie = document.cookie;
      var ca = decodedCookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
    linkToRouterPush() {
      let allAtags = document.getElementsByTagName("a");
      allAtags.forEach((tag) => {
        let routeVal = tag.getAttribute("href");
        let menu = tag.getAttribute("element-type");
        if (routeVal && !menu) {
          if (routeVal.indexOf("/") == 0) {
            tag.removeAttribute("href");
            tag.addEventListener("click", function () {
              vm.$router.push(routeVal);
            });
          }
        }
      });
    },
    linkToRouterPush_Back() {
      let allAtags = document.getElementsByTagName("a");
      allAtags.forEach((tag) => {
        let routeVal = tag.getAttribute("href");
        let dtl = tag.getAttribute("dynamic-html-link");
        if (dtl) {
          if (routeVal && routeVal.indexOf("/") >= 0) {
            tag.removeAttribute("href");
            tag.addEventListener("click", function (e) {
              console.log(e);
              //self.routerHandler(routeVal);
              if (routeVal.includes("http")) {
                window.open(routeVal);
              } else {
                //alert("push");
                vm.$router.push(routeVal);
              }
            });
          }
        }
      });
    },
    detectScreenOrientation: function () {
      var sWidth = screen.width;
      var sHeight = screen.height;
      if (sWidth > sHeight) {
        self.IsLandscape = true;
      } else {
        self.IsLandscape = false;
      }
    },
    SubscribeForWebPush() {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      // alert("obj.ShowNotification lobby:- " + obj.ShowNotification);
      eventsubscribe.SubscribeUser(
        obj.eventcollectionname,
        obj.user[0].Email,
        obj.user[0].id,
        obj.ShowNotification
      );
    },
    getMeetingSettings: function () {
      //debugger;
      const obj = JSON.parse(window.localStorage["my-app"]);
      let headers = {
        Authorization: "Bearer " + vm.getSessionToken(),
        "content-type": "application/json",
      };
      let requestData = {
        key: {
          instanceId: "OA_UAT",
          clientId: obj.client[0].id,
          eventId: obj.eventid,
        },
      };
      axios
        .post(vm.APIs.MeetingAPIConfig.GetConfig, JSON.stringify(requestData), {
          headers: headers,
        })
        .then((response) => {
          //debugger;
          console.log(response);
          var res = response.data;
          var MObj = new Object();
          MObj.Slot = res.data.Slots;
          MObj.StartDate = res.data.StartDate;
          MObj.EndDate = res.data.EndDate;
          MObj.AvailabilityFromTime = res.data.AvailabilityFromTime;
          MObj.AvailabilityToTime = res.data.AvailabilityToTime;
          MObj.ButtonLabel = res.data.ButtonLabel;
          MObj.Duration = res.data.Duration;
          if (res.data.ByTimezone !== undefined) {
            MObj.ByTimezone = res.data.ByTimezone;
          } else {
            MObj.ByTimezone = false;
          }

          store.commit("addMeetingSettings", MObj);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    fetchLeftPhotoAlbum: function () {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      var docref = db.collection(obj.eventcollectionname).doc("VirtualLobby");
      //$("#dvLeftPanelItem").css("border-color", "Green");

      var AlbumNamesForLeftPanel = [];
      docref.get().then((doc) => {
        var data = doc.data();
        vm.leftPhotoScrollDelay =
          parseInt(data.LeftPanelImageTransitionDelay) * 1000;
        vm.leftPanelBordercolor = data.coundownLobby.sponsorBorderColor;

        //  document.getElementById("dvLeftPanelItem").style.borderColor = "red";
        // el = document.getElementById("color");

        // console.log("left delay:- " + vm.leftPhotoScrollDelay);
        $.each(data.LeftPanelPhotoWallAlbum, function (key, value) {
          AlbumNamesForLeftPanel.push(value);
        });
        //debugger;
        //---------------------------------------------------------------------------
        $.each(AlbumNamesForLeftPanel, function (key, value) {
          var albumname = value.photoDirectory;
          var albumRef = db
            .collection(obj.eventcollectionname)
            .doc("PhotoWall")
            .collection(albumname);

          var objAlbum = new Object();

          objAlbum.headerText = albumname;
          objAlbum.photoList = [];
          vm.leftPanelPhotoArray.push(objAlbum);
          //------------------------------------------------------------------

          albumRef.get().then((querySnapshot) => {
            if (querySnapshot.docs.length > 0) {
              var filteredAlbum = vm.leftPanelPhotoArray.filter(function (
                value
              ) {
                return value.headerText == albumname;
              });
              var currentAlbum;
              if (filteredAlbum.length > 0) {
                currentAlbum = filteredAlbum[0];
                querySnapshot.forEach((doc) => {
                  // console.log(doc.data());
                  if (doc.data().IsPublished) {
                    var obj = new Object();
                    //obj.headerText = albumname;
                    obj.imgUrl = doc.data().photoUrl;
                    currentAlbum.photoList.push(obj);
                    // vm.leftPanelPhotoArray.push(obj);
                  }
                });
              }
            }

            // console.log(currentAlbum);
          });
        });
        //----------------------------------------------------------------------------
      });
      //  console.log(AlbumNamesForLeftPanel);
    },
    fetchRightPhotoAlbum: function () {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      var docref = db.collection(obj.eventcollectionname).doc("VirtualLobby");
      var AlbumNamesForRightPanel = [];
      docref.get().then((doc) => {
        var data = doc.data();
        vm.rightPhotoScrollDelay =
          parseInt(data.RightPanelImageTransitionDelay) * 1000;
        vm.rightPanelBordercolor = data.coundownLobby.photoWallBorderColor;

        //-----------------------------------------------------------------------

        //  console.log("right delay:- " + vm.rightPhotoScrollDelay);
        $.each(data.RightPanelPhotoWallAlbum, function (key, value) {
          AlbumNamesForRightPanel.push(value);
        });

        //---------------------------------------------------------------------------
        $.each(AlbumNamesForRightPanel, function (key, value) {
          var albumname = value.photoDirectory;
          var albumRef = db
            .collection(obj.eventcollectionname)
            .doc("PhotoWall")
            .collection(albumname);

          var objAlbum = new Object();

          objAlbum.headerText = albumname;
          objAlbum.rightPhotoList = [];
          vm.rightPanelPhotoArray.push(objAlbum);
          //------------------------------------------------------------------

          albumRef.get().then((querySnapshot) => {
            if (querySnapshot.docs.length > 0) {
              var filteredAlbum = vm.rightPanelPhotoArray.filter(function (
                value
              ) {
                return value.headerText == albumname;
              });
              var currentAlbum;
              if (filteredAlbum.length > 0) {
                currentAlbum = filteredAlbum[0];
                querySnapshot.forEach((doc) => {
                  // console.log(doc.data());
                  if (doc.data().IsPublished) {
                    var obj = new Object();
                    //obj.headerText = albumname;
                    obj.imgUrl = doc.data().photoUrl;
                    currentAlbum.rightPhotoList.push(obj);
                    // vm.rightPanelPhotoArray.push(obj);
                  }
                });
              }
            }

            // console.log(currentAlbum);
          });
        });
        //----------------------------------------------------------------------------
      });
    },
    ConnectFirebaseDB: function () {
      //
      if (eventSettingsQuery != undefined) {
        eventSettingsQuery();
      }

      // Left Photowall
      if (photoWallQueryLeft != undefined) {
        photoWallQueryLeft();
      }
      if (photoWallQueryLeft == undefined) {
        photoWallQueryLeft = db
          .collection(vm.eventColectionName)
          .doc("PhotoWall")
          //.collection("Images").where("photoDirectory","==",vm.photoDirectoryLeft)
          .collection("Images")
          .onSnapshot((querySnapshot) => {
            //
            let changes = querySnapshot.docChanges();
            var photoList = [];
            var photoChanged = false;
            for (let change of changes) {
              var doc = change.doc;

              var id = doc.id;
              var data = doc.data();
              if (data.photoDirectory == vm.photoDirectoryLeft) {
                photoChanged = true;
                var imgItem = new Object();
                imgItem.id = id;
                imgItem.photourl = data.photourl;
                imgItem.CreatedTime = data.ModifiedTime; //data.CreatedTime;
                imgItem.LikeUserIDs = data.LikeUserIDs;
                imgItem.Likes = data.Likes;
                if (change.type == "added" || change.type == "modified") {
                  var indx = photoWallItemIdsLeft.indexOf(id);
                  if (indx == -1) {
                    if (data.Status == 1) {
                      photoWallItemIdsLeft.push(id);
                      photoList.push(imgItem);
                    }
                  } else {
                    if (data.Status != 1) {
                      photoWallItemIdsLeft = photoWallItemIdsLeft.filter(
                        function (value) {
                          return value != id;
                        }
                      );
                      photoList = photoList.filter(function (value) {
                        return value.id != id;
                      });
                    }
                  }
                } else if (change.type == "removed") {
                  var indx1 = photoWallItemIdsLeft.indexOf(id);
                  if (indx1 != -1) {
                    photoWallItemIdsLeft = photoWallItemIdsLeft.filter(
                      function (value) {
                        return value != id;
                      }
                    );
                    photoList = photoList.filter(function (value) {
                      return value.id != id;
                    });
                  }
                }
              }
            }
            if (photoChanged) {
              photoList.sort(vm.SortArrayByTime);
              for (let photo of photoList) {
                vm.photoWallItemsLeft.push(photo);
              }
              //vm.RefreshPhotoWall(vm.photoWallItems);

              vm.RefreshPhotoWallLeft();
            }
          });
      }

      // Right Photowall

      if (photoWallQueryRight != undefined) {
        photoWallQueryRight();
      }
      if (photoWallQueryRight == undefined) {
        photoWallQueryRight = db
          .collection(vm.eventColectionName)
          .doc("PhotoWall")
          //.collection("Images").where("photoDirectory","==",vm.photoDirectoryRight)
          .collection("Images")
          .onSnapshot((querySnapshot) => {
            //
            //
            let changes = querySnapshot.docChanges();
            var photoList = [];
            //console.log(photoList);
            var photoChanged = false;
            for (let change of changes) {
              var doc = change.doc;
              var id = doc.id;
              var data = doc.data();
              if (data.photoDirectory == vm.photoDirectoryRight) {
                var imgItem = new Object();
                imgItem.id = id;
                imgItem.photourl = data.photourl;
                imgItem.CreatedTime = data.ModifiedTime; //data.CreatedTime;
                imgItem.LikeUserIDs = data.LikeUserIDs;
                imgItem.Likes = data.Likes;
                if (change.type == "added" || change.type == "modified") {
                  var indx = photoWallItemIdsRight.indexOf(id);
                  if (indx == -1) {
                    if (data.Status == 1) {
                      photoWallItemIdsRight.push(id);
                      photoList.push(imgItem);
                    }
                  } else {
                    if (data.Status != 1) {
                      photoWallItemIdsRight = photoWallItemIdsRight.filter(
                        function (value) {
                          return value != id;
                        }
                      );
                      photoList = photoList.filter(function (value) {
                        return value.id != id;
                      });
                    }
                  }
                } else if (change.type == "removed") {
                  var indx1 = photoWallItemIdsRight.indexOf(id);
                  if (indx1 != -1) {
                    photoWallItemIdsRight = photoWallItemIdsRight.filter(
                      function (value) {
                        return value != id;
                      }
                    );
                    photoList = photoList.filter(function (value) {
                      return value.id != id;
                    });
                  }
                }
              }
            }
            if (photoChanged) {
              photoList.sort(vm.SortArrayByTime);
              for (let photo of photoList) {
                vm.photoWallItemsRight.push(photo);
              }
              //vm.RefreshPhotoWall(vm.photoWallItems);
              vm.RefreshPhotoWallRight();
            }
          });
      }

      if (eventSettingsQuery == undefined) {
        eventSettingsQuery = db
          .collection(vm.eventColectionName) //.doc("EventSettings")
          .onSnapshot((querySnapshot) => {
            let changes = querySnapshot.docChanges();
            for (let change of changes) {
              var doc = change.doc;

              if (doc.id == "EventSettings") {
                vm.loginEnabled = parseInt(doc.data().EnableLogin) == 1;
                vm.eventStartTime = doc.data().StartDateTime;
                vm.countDownMinutes = parseInt(doc.data().CountDownTime);
                vm.autoSwitchPage = doc.data().AutoSwitchPage == 1;
                if (change.type == "added") {
                  if (doc.data().StartDateTime != undefined) {
                    //vm.checkCountDountAuth();
                  }

                  //createUserLog("Lobby");
                } else if (change.type == "modified") {
                  if (doc.data().StartDateTime != undefined) {
                    //vm.checkCountDountAuth();
                  }
                }
              }
            }
          });
      }
    },

    featchVirtualLobby: function () {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      // console.log("EventColName : " + obj.eventcollectionname);
      var ref = db.collection(obj.eventcollectionname).doc("VirtualLobby");
      //console.log(ref);
      let that = this;
      ref
        .get()
        .then(function (doc) {
          vm.SubscribeForWebPush(); //kk
          if (doc.exists) {
            let docObj = new Object();
            docObj = doc.data();
            // console.log("Document data:", doc.data());
            //console.log(docObj);
            //var coundownLobby = docObj.coundownLobby;
            console.log("join button url:-" + doc.data().JoinButtonUrl);
            if (docObj.RoomId != undefined) {
              vm.chatRoomId = docObj.RoomId;
            }

            vm.saudiLobbyVideoUrl = "";
            if (
              docObj.ImgHotspotHTML != undefined &&
              docObj.ImgHotspotHTML != ""
            ) {
              var html = docObj.ImgHotspotHTML;
              var sourceMatch = html.match(
                /<source[^>]*\ssrc=["']([^"']+)["']/i
              );
              if (sourceMatch) {
                vm.saudiLobbyVideoUrl = sourceMatch[1];
              } else {
                var videoMatch = html.match(
                  /<video[^>]*\ssrc=["']([^"']+)["']/i
                );
                if (videoMatch) vm.saudiLobbyVideoUrl = videoMatch[1];
              }
            }

            if (docObj.Popup != undefined) {
              vm.lobbyPopupType = docObj.Popup.ResourceType;
              vm.lobbyPopupHeader = docObj.Popup.PopupTitle;
              vm.lobbyPopupResourceUrl = docObj.Popup.ResourceUrl;

              var cookieName1 = obj.eventcollectionname + "_" + "LobbyPupup";
              var cookieData1 = vm.getCookie(cookieName1);

              setTimeout(() => {
                if (cookieData1 == "") {
                  if (vm.videoPlaySettings == "1 time play") {
                    var value = cookieName1 + `=['Lobby'] ;path=/`;
                    document.cookie = value;
                    vm.showLobbyPopup =
                      docObj.Popup.IsPublished == true ? true : false;
                  } else {
                    vm.showLobbyPopup =
                      docObj.Popup.IsPublished == true ? true : false;
                  }
                }
              }, 1000);
            }

            vm.MainJoinButtonUrl =
              doc.data().JoinButtonUrl != undefined
                ? doc.data().JoinButtonUrl
                : "/sessions";

            if (that.$store.state.eventDefaultSessionPage) {
              vm.MainJoinButtonUrl = that.$store.state.eventDefaultSessionPage;
            }
            //------------------------------------------------------------------------------
            self.joinButtonText = docObj.JoinButtonText;
            //console.log(self.joinButtonText);
            if (self.joinButtonText != undefined) {
              if (self.joinButtonText != "") {
                document.getElementById("pJoinbuttonText").innerText =
                  self.joinButtonText;
              } else {
                document.getElementById("pJoinbuttonText").innerText =
                  "CLICK HERE NOW TO JOIN";
              }
            } else {
              document.getElementById("pJoinbuttonText").innerText =
                "CLICK HERE NOW TO JOIN";
            }

            //------------------------------------------------------------------------
            document.getElementById("headerText").innerHTML =
              docObj.headlineText;
            //---------------------------------------------------------------------
            vm.EnableSubButtons =
              doc.data().EnableSubButtons != undefined
                ? doc.data().EnableSubButtons
                : false;

            if (doc.data().AdditionalButtons != undefined) {
              //-----------------------------------------------------------

              // if (doc.data().AdditionalButtons.LeftSubButtonLabel != "") {
              //   vm.leftButtonText =
              //     doc.data().AdditionalButtons.LeftSubButtonLabel != undefined
              //       ? doc.data().AdditionalButtons.LeftSubButtonLabel
              //       : "";
              //   vm.showLeftButton = true;
              // } else {
              //   vm.showLeftButton = false;
              // }
              vm.leftButtonText =
                doc.data().AdditionalButtons.LeftSubButtonLabel != undefined
                  ? doc.data().AdditionalButtons.LeftSubButtonLabel
                  : "";

              // vm.leftbuttonRoute =
              //   doc.data().AdditionalButtons.LeftSubButtonURL != undefined
              //     ? doc.data().AdditionalButtons.LeftSubButtonURL
              //     : "";
              if (doc.data().AdditionalButtons.LeftSubButtonURL != "") {
                vm.leftbuttonRoute =
                  doc.data().AdditionalButtons.LeftSubButtonURL != undefined
                    ? doc.data().AdditionalButtons.LeftSubButtonURL
                    : "";
                vm.showLeftButton = true;
              } else {
                vm.showLeftButton = false;
              }

              //-------------------------------------------------------------
              // if (doc.data().AdditionalButtons.MiddleSubButtonLabel != "") {
              //   vm.middleButtonText =
              //     doc.data().AdditionalButtons.MiddleSubButtonLabel != undefined
              //       ? doc.data().AdditionalButtons.MiddleSubButtonLabel
              //       : "";
              //   vm.showMiddleButton = true;
              // } else {
              //   vm.showMiddleButton = false;
              // }

              vm.middleButtonText =
                doc.data().AdditionalButtons.MiddleSubButtonLabel != undefined
                  ? doc.data().AdditionalButtons.MiddleSubButtonLabel
                  : "";
              if (doc.data().AdditionalButtons.MiddleSubButtonURL != "") {
                vm.MiddleButtonRoute =
                  doc.data().AdditionalButtons.MiddleSubButtonURL != undefined
                    ? doc.data().AdditionalButtons.MiddleSubButtonURL
                    : "";
                vm.showMiddleButton = true;
              } else {
                vm.showMiddleButton = false;
              }
              //-------------------------------------------------
              // if (doc.data().AdditionalButtons.RightSubButtonLabel != "") {
              //   // vm.rightButtonText =
              //   //   doc.data().AdditionalButtons.RightSubButtonLabel != undefined
              //   //     ? doc.data().AdditionalButtons.RightSubButtonLabel
              //   //     : "";
              //   vm.showRightButton = true;
              // } else {
              //   vm.showRightButton = false;
              // }
              vm.rightButtonText =
                doc.data().AdditionalButtons.RightSubButtonLabel != undefined
                  ? doc.data().AdditionalButtons.RightSubButtonLabel
                  : "";
              if (doc.data().AdditionalButtons.RightSubButtonURL != "") {
                vm.rightButtonRoute =
                  doc.data().AdditionalButtons.RightSubButtonURL != undefined
                    ? doc.data().AdditionalButtons.RightSubButtonURL
                    : "";
                vm.showRightButton = true;
              } else {
                vm.showRightButton = false;
              }
            }
            //=---------------------------------------------------------------------

            if (docObj.hostedBy != undefined && docObj.hostedBy != "") {
              document.getElementById("hostedByLabel").innerHTML =
                docObj.hostedBy;
              console.log("hb======", docObj.hostedBy);
              $("#hostedByDiv").css(
                "color",
                docObj.coundownLobby.HeaderTextColor
              );
            } else {
              document.getElementById("hostedByDiv").style.display = "none";
              console.log("hb=2=====", docObj.hostedBy);
            }
            //=---------------------------------------------------------------------
            document.getElementById("leftWallHeading").innerHTML =
              docObj.PhotoScrollLeftHeading;
            document.getElementById("rightWallHeading").innerHTML =
              docObj.PhotoScrollRightHeading;
            if (
              docObj.PhotoScrollLeftSubHeading != undefined &&
              docObj.PhotoScrollLeftSubHeading != ""
            ) {
              document.getElementById("leftWallHeadingSub").innerHTML =
                docObj.PhotoScrollLeftSubHeading;
            } else {
              document.getElementById("leftWallHeadingSub").style.display =
                "none";
              $("#sponsor-slide").addClass("active");
            }
            if (
              docObj.PhotoScrollRightSubHeading != undefined &&
              docObj.PhotoScrollRightSubHeading != ""
            ) {
              document.getElementById("rightWallHeadingSub").innerHTML =
                docObj.PhotoScrollRightSubHeading;
            } else {
              document.getElementById("rightWallHeadingSub").style.display =
                "none";
              $("#divProfileItemsWrap1").addClass("active");
            }
            //------------------------------------------------------------------------------
            $("#SponsorTopText").css(
              "color",
              docObj.coundownLobby.HeaderTextColor
            );
            // Get the element with id="myDIV" (a div), then get all elements inside div with class="example"
            var x = document
              .getElementById("SponsorTopText")
              .querySelectorAll(".clssponsorText");

            // Set the background color of the first element with class="example" (index 0) in div
            x[0].style.color = docObj.coundownLobby.HeaderTextColor;
            x[1].style.color = docObj.coundownLobby.HeaderTextColor;
            //---------------------------------------------------------------------------------
            $("#PhotoWallTopText").css(
              "color",
              docObj.coundownLobby.HeaderTextColor
            );
            // Get the element with id="myDIV" (a div), then get all elements inside div with class="example"
            var y = document
              .getElementById("PhotoWallTopText")
              .querySelectorAll(".clsPhotoText");

            // Set the background color of the first element with class="example" (index 0) in div
            y[0].style.color = docObj.coundownLobby.HeaderTextColor;

            //--------------------------------------------------------------------------------
            var JoinButtonShadowColor =
              "0 10px 0 0 " + docObj.coundownLobby.joinButtonShadowColor;
            //console.log("BG::" + docObj.coundownLobby.bgImagePath);
            // ----------------Lobby Branding--------------------------
            var screenWidth = screen.width;
            console.log("Total Width: " + screenWidth);
            self.portraitBGurl = docObj.coundownLobby.bgImageIpad;
            self.landscapeBGurl = docObj.coundownLobby.bgImagePath;
            console.log("i-pad:- " + docObj.coundownLobby.bgImageIpad);
            /*  if (!self.IsLandscape) {
              if (docObj.coundownLobby.bgImageIpad != undefined) {
                if (docObj.coundownLobby.bgImageIpad != "") {
                  $("#lobby_page").css(
                    "background-image",
                    "url(" + docObj.coundownLobby.bgImageIpad + ")"
                  );
                } else {
                  $("#lobby_page").css(
                    "background-image",
                    "url(" + docObj.coundownLobby.bgImagePath + ")"
                  );
                }
              } else {
                $("#lobby_page").css(
                  "background-image",
                  "url(" + docObj.coundownLobby.bgImagePath + ")"
                );
              }
            } else {
              $("#lobby_page").css(
                "background-image",
                "url(" + docObj.coundownLobby.bgImagePath + ")"
              );
            }*/
            $("#headerText").css("color", docObj.coundownLobby.HeaderTextColor);
            $("#TimerHeader").css(
              "color",
              docObj.coundownLobby.HeaderTextColor
            );

            $("#sponsorPanel").css(
              "border-color",
              docObj.coundownLobby.sponsorBorderColor
            );
            $("#sponsorPanel").css(
              "background-color",
              docObj.coundownLobby.sponsorBGColor
            );

            $("#linkGoToSite").css(
              "background-color",
              docObj.coundownLobby.joinButtonBGColor
            );
            $("#linkGoToSite").css(
              "color",
              docObj.coundownLobby.joinButtonFontColor
            );
            $("#linkGoToSite").css("box-shadow", JoinButtonShadowColor);

            $("#divProfileContanier1").css(
              "border-color",
              docObj.coundownLobby.photoWallBorderColor
            );
            $("#divProfileContanier1").css(
              "background-color",
              docObj.coundownLobby.photoWallBGColor
            );

            var leftPhotowall = docObj.HidePhotoScrollLeft;
            var rightPhotowall = docObj.HidePhotoScrollRight;
            var HideBottomMenu = docObj.HideBottomMenu;
            if (leftPhotowall == "ShowPhotoScrollLeftHide") {
              $("#sponsors").css("visibility", "hidden");
              $("#leftTab").addClass("hide");
            } else {
              $("#sponsors").css("visibility", "visible");
            }
            if (rightPhotowall == "ShowPhotoScrollRightHide") {
              $("#photowall").css("visibility", "hidden");
              $("#rightTab").addClass("hide");
            } else {
              $("#photowall").css("visibility", "visible");
            }
            if (HideBottomMenu == "false") {
              $("#divEventBtns").css("display", "block");
            } else {
              $("#divEventBtns").css("display", "none");
            }
            // ----------------Lobby Branding--------------------------
            vm.isMusicEnabled = docObj.IsMusicEnable;

            var CountDownMinits = parseInt(docObj.CountDownTime);
            //var countDownDate = parseInt(new Date("July 9, 2020 18:50:00").getTime()/1000);
            var countDownDate = vm.eventStartTime;

            vm.photoDirectoryLeft = docObj.PhotoScrollerLeft;
            vm.photoDirectoryRight = docObj.PhotoScrollerRight;
            var musicUrl = docObj.MusicURL;
            var isHotspotEnable = docObj.IsHotspotEnable;
            var isMouseCursorEnable = docObj.IsMouseCursorEnable;

            if (vm.LobbyType == 1) {
              if (screen.width < 767) {
                $(".lobby-music_mobile").attr("src", musicUrl);
              } else {
                $(".lobby-music").attr("src", musicUrl);
              }
              if (musicUrl == "") {
                $("#audioWrapper").fadeOut();
              }
              //  vm.ConnectFirebaseDB();
              vm.fetchLeftPhotoAlbum();
              vm.fetchRightPhotoAlbum();
              //debugger;
              vm.CheckCountDown(countDownDate, CountDownMinits);
              $("#dvlobby").hide();
              $("#lobby_page").show();
              // $("#topmenu").hide();
              // $("#leftmenu").hide();
            } else {
              vm.LobbyMusicURL = vm.getCDNUrl(musicUrl);
              if (isHotspotEnable == false) {
                var replaceTxt = docObj.ImgHotspotHTML.replace(
                  /class="dot"/g,
                  ""
                );
                vm.customHtml = replaceTxt;
              } else if (isMouseCursorEnable == false) {
                var replaceTxt1 = docObj.ImgHotspotHTML.replace(
                  /class="mouse-cursor"/g,
                  ""
                );
                vm.customHtml = self.getCDNUrl(replaceTxt1);
                vm.turnONOFFPointer = true;
              } else if (isMouseCursorEnable == true) {
                var replaceTxt2 = docObj.ImgHotspotHTML.replace(
                  /class="mouse-hide"/g,
                  ""
                );
                vm.customHtml = self.getCDNUrl(replaceTxt2);
              } else {
                vm.customHtml = self.getCDNUrl(docObj.ImgHotspotHTML);
              }

              if (vm.videoPlaySettings == "1 time play") {
                var cookieName =
                  vm.eventColectionName + "_" + "videoPlaySettings";
                var cookieData = vm.getCookie(cookieName);

                if (cookieData == "") {
                  var value = cookieName + `=['Lobby'] ;path=/`;
                  document.cookie = value;
                } else {
                  var replaceYoutube = docObj.ImgHotspotHTML.replace(
                    /autoplay=1/g,
                    "autoplay=0"
                  );
                  replaceYoutube = docObj.ImgHotspotHTML.replace(
                    /allow="autoplay"/g,
                    ""
                  );

                  vm.customHtml = replaceYoutube;
                }
              }

              //vm.customHtml = vm.customHtml.replace(
              //  /href/g,
              //  "dynamic-html-link='true' href"
              //);
              $("#dvlobby").css("display", "flex");
              $("#lobby_page").hide();
              //if lobby type custom html

              if (screen.width < 767) {
                $(".lobby-music_mobile").attr("src", "");
                $(".lobby-music").attr("src", "");
              } else {
                $(".lobby-music").attr("src", "");
              }
              // $("#topmenu").hide();
              // $("#leftmenu").hide();
            }
          } else {
            // doc.data() will be undefined in this case
            console.log(
              "Attn Event Planner: Please login to CMS and setup the Virtual Lobby to continue "
            );
            alert(vm.$t("lobby.attnalert"));

            if (that.$store.state.eventDefaultSessionPage) {
              vm.MainJoinButtonUrl = that.$store.state.eventDefaultSessionPage;
            }

            $("#countDownText").hide();
            $("#lobby_page").removeClass("active");
            $("#divGoToSite").show();
            $("#lobby_page").show();
          }
          vm.isLoading = false;
        })
        .catch(function (error) {
          console.log("Error getting mapped attendee:", error);
          // reject(error)
        });
    },

    startCountDown: function (countDownDate) {
      countDownDate = countDownDate * 1000;

      // Update the count down every 1 second
      var x = setInterval(function () {
        // Get today's date and time
        var now = new Date().getTime();

        // Find the distance between now and the count down date
        var distance = countDownDate - now;

        // Time calculations for days, hours, minutes and seconds
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));

        var dayDigit1 = "";
        var dayDigit2 = "";

        if (days.toString().length == 1) {
          dayDigit1 = "0";
          dayDigit2 = days;
        } else {
          dayDigit1 = days.toString().substring(0, 1);
          dayDigit2 = days.toString().substring(1, 2);
        }

        var hours = Math.floor(
          (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        var hours1 = "";
        var hours2 = "";
        if (hours.toString().length == 1) {
          hours1 = "0";
          hours2 = hours;
        } else {
          hours1 = hours.toString().substring(0, 1);
          hours2 = hours.toString().substring(1, 2);
        }

        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var minutes1 = "";
        var minutes2 = "";
        if (minutes.toString().length == 1) {
          minutes1 = "0";
          minutes2 = minutes;
        } else {
          minutes1 = minutes.toString().substring(0, 1);
          minutes2 = minutes.toString().substring(1, 2);
        }

        var seconds = Math.floor((distance % (1000 * 60)) / 1000);
        var seconds1 = "";
        var seconds2 = "";
        if (seconds.toString().length == 1) {
          seconds1 = "0";
          seconds2 = seconds;
        } else {
          seconds1 = seconds.toString().substring(0, 1);
          seconds2 = seconds.toString().substring(1, 2);
        }

        document.getElementById("countDays1").innerHTML = dayDigit1;
        document.getElementById("countDays2").innerHTML = dayDigit2;

        document.getElementById("countHours1").innerHTML = hours1;
        document.getElementById("countHours2").innerHTML = hours2;

        document.getElementById("countMinutes1").innerHTML = minutes1;
        document.getElementById("countMinutes2").innerHTML = minutes2;

        document.getElementById("countSeconds1").innerHTML = seconds1;
        document.getElementById("countSeconds2").innerHTML = seconds2;

        // If the count down is over, write some text
        if (distance <= 0) {
          clearInterval(x);
          $("#divGoToSite").show();
          $("#countDownText").hide();
          //$("#lobby_page").removeClass("active");
          router.push("/livestage");
        }
      }, 1000);

      console.log(":::: ");
    },

    CheckCountDown: function (eventTime, countDownMinutes) {
      //debugger;
      $("#divGoToSite").show();
      $("#countDownText").hide();
      //$("#lobby_page").removeClass("active");

      var currentTime = parseInt(new Date().getTime() / 1000);
      if (currentTime <= eventTime) {
        var remainingSeconds =
          eventTime - parseInt(new Date().getTime() / 1000);
        if (remainingSeconds > 0) {
          if (remainingSeconds <= countDownMinutes * 60) {
            vm.startCountDown(eventTime);
            $("#divGoToSite").hide();
            $("#countDownText").show();
            common.toggleTopMenu(false);
            common.toggleLeftMenu(false);
            //$("#topmenu").hide();
            //$("#leftmenu").hide();
            //$("#lobby_page").addClass("active");
          } else {
            common.toggleTopMenu(true);
            common.toggleLeftMenu(true);
            //$("#topmenu").show();
            //$("#leftmenu").show();
          }
        }
      }
    },

    getAttendeeID: function () {
      //
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      var email = obj.user[0].Email;
      //var EventID = obj.eventid;

      db.collection(vm.eventColectionName)
        .doc("AttendeeList")
        .collection("Attendees")
        .where("Email", "==", email)
        //.where("MappedEvents", "array-contains", EventID)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            //
            var data = doc.data();
            var AttendeeID = data.AttendeeId;
            store.commit("addAttendeeID", AttendeeID);
          });
        })
        .catch((error) => {
          //alert(error);
          console.log(error);
        });
    },

    SortArrayByTime: function (a, b) {
      var val1 = a.CreatedTime;
      var val2 = b.CreatedTime;
      return val1 > val2 ? -1 : val1 < val2 ? 1 : 0;
    },

    //Bootstrap Carousel
    RefreshPhotoWallLeft: function () {
      //vm.hooper.slideNext();
      //vm.hooper.slideNext();
      if (vm.hooper != undefined) {
        vm.hooper.restart();
      }
    },
    RefreshPhotoWallRight: function () {
      //vm.hooper.slideNext();
      //vm.hooper.slideNext();
      vm.hooper.restart();
    },
    LobbyMusicMuted: function () {
      if (screen.width < 767) {
        $(".lobby-music_mobile").prop("muted", true);
        $("#loobyMusic_pause_mobile").hide();
        $("#loobyMusic_play_mobile").show();
        $("#loobyMusic_play1_mobile").show();
        $("#loobyMusic_pause1_mobile").hide();
      } else {
        $(".lobby-music").prop("muted", true);
        $("#loobyMusic_play").show();
        $("#loobyMusic_pause").hide();
        $("#loobyMusic_play1").show();
        $("#loobyMusic_pause1").hide();
      }
    },
    LobbyMusicUnmuted: function () {
      if (screen.width < 767) {
        $(".lobby-music_mobile").prop("muted", false);
        $("#loobyMusic_play_mobile").hide();
        $("#loobyMusic_pause_mobile").show();
        $("#loobyMusic_play1_mobile").hide();
        $("#loobyMusic_pause1_mobile").show();
      } else {
        $(".lobby-music").prop("muted", false);

        $("#loobyMusic_play").hide();
        $("#loobyMusic_pause").show();
        $("#loobyMusic_play1").hide();
        $("#loobyMusic_pause1").show();
      }
    },
    featchEventInfo: function () {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      //console.log("EventColName : " + obj.eventcollectionname);
      var ref = db.collection(obj.eventcollectionname).doc("EventInfo");

      ref
        .get()
        .then(function (doc) {
          if (doc.exists) {
            let docObj = new Object();
            docObj = doc.data();
            store.commit(
              "setEventDefaultSessionPage",
              docObj.DefaultSessionPath
            );
            store.commit("addZone", doc.data().TimeZone);
            if (screen.width < 767) {
              vm.LobbyType = 1;
            } else {
              vm.LobbyType = docObj.LobbyType;
            }

            vm.videoPlaySettings = docObj.videoPlaySettings;
            store.commit("setVideoPlaySettings", vm.videoPlaySettings);

            // if(vm.LobbyType == 2){
            //     $("#lobby_page").html(vm.customHtml);
            //   }else{
            //     console.log(vm.customHtml);
            // }

            //alert(vm.LobbyType);

            vm.featchVirtualLobby();
            // vm.SubscribeForWebPush();kk
          } else {
            // doc.data() will be undefined in this case
            console.log("No such document!");
          }
        })
        .catch(function (error) {
          console.log("Error getting mapped attendee:", error);
          // reject(error)
        });
    },
    clearstate: function () {
      store.commit("ClearState", this);
      document.cookie = "vuid=; path=/;domain=.e2m.live;secure=true";
      //document.cookie.removeCookie("vuid");
      location.href = "/";
    },
    getAdvExpoStatus: function () {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      db.collection(obj.eventcollectionname)
        .doc("Settings")
        .collection("Exhibitor")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            if (doc.data().EnableEnhancedExpoMode === true) {
              store.commit("setAdvExpo", true);
            } else {
              store.commit("setAdvExpo", false);
            }
          });
        })
        .catch((error) => {
          alert(error);
        });
    },

    routerPush: function (pagename) {
      router.push("/" + pagename);
    },
    // leftMenuDisplay: function(){
    //   if( $("#ulLeftMenu:empty")){
    //     $("#lobby_page").addClass("pl-0");
    //   }
    //   else{
    //     $("#lobby_page").removeClass("pl-0");
    //     console.log("No Left Menu")
    //   }
    // }
    setOtherParams: function () {
      if (this.$route.params.sid != "") {
        if (typeof this.$route.params.sid !== "undefined") {
          store.commit("addEventID", this.$route.params.sid);
        }
      }

      if (this.$route.params.eCol != "") {
        if (typeof this.$route.params.eCol !== "undefined") {
          store.commit("addEventCollection", this.$route.params.eCol);
        }
      }

      if (this.$route.params.ename != "") {
        if (typeof this.$route.params.ename !== "undefined") {
          store.commit("addEventName", this.$route.params.ename);
        }
      }

      if (this.$route.params.estartdt != "") {
        if (typeof this.$route.params.estartdt !== "undefined") {
          store.commit("addEventSdate", this.$route.params.estartdt);
        }
      }

      if (this.$route.params.eenddt != "") {
        if (typeof this.$route.params.eenddt !== "undefined") {
          store.commit("addEventEdate", this.$route.params.eenddt);
        }
      }

      if (this.$route.params.tzone != "") {
        if (typeof this.$route.params.tzone !== "undefined") {
          store.commit("addZone", this.$route.params.tzone);
        }
      }
    },

    getDynamicFont: function () {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      if (obj.EventFont != undefined) {
        if (obj.EventFont.length > 0) {
          //debugger;
          var urlpath = "";
          if (obj.EventFont[0].FontPath != "") {
            if (obj.EventFont[0].FontFamily != "") {
              urlpath = obj.EventFont[0].FontPath;

              var newStyle = document.createElement("style");
              newStyle.appendChild(
                document.createTextNode(
                  "\
@font-face {\
    font-family: " +
                    obj.EventFont[0].FontFamily +
                    ";\
    src:" +
                    urlpath +
                    " ;\
}\
"
                )
              );

              document.head.appendChild(newStyle);

              $(
                "<style>* { font-family: '" +
                  obj.EventFont[0].FontFamily +
                  "' !important }</style>"
              ).appendTo("head");
            }
          } else {
            $("<style>* { font-family: 'Roboto' !important }</style>").appendTo(
              "head"
            );
          }
        }
      }
    },
  },
};
</script>

<style>
.audio-control {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.audio-control button {
  background: none;
  border: none;
  padding: 0;
  width: 100%;
  height: 100%;
}
.audio-vol-icon {
  height: 35px;
  width: 35px;
  background: #fff;
  border-radius: 50%;
  margin: 50px auto 30px;

  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

#sponsors,
#photowall {
  visibility: hidden;
}
</style>
<style scoped>
.v-skeleton-loader__image .v-skeleton-loader__bone {
  height: 100%;
  width: 100%;
}
</style>
